(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3aac"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3aac"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dc6El", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99b18dd98d1424fc$export$2e2bcd8739ae039; });
// packages/alpinejs/src/scheduler.js
var $99b18dd98d1424fc$var$flushPending = false;
var $99b18dd98d1424fc$var$flushing = false;
var $99b18dd98d1424fc$var$queue = [];
var $99b18dd98d1424fc$var$lastFlushedIndex = -1;
function $99b18dd98d1424fc$var$scheduler(callback) {
    $99b18dd98d1424fc$var$queueJob(callback);
}
function $99b18dd98d1424fc$var$queueJob(job) {
    if (!$99b18dd98d1424fc$var$queue.includes(job)) $99b18dd98d1424fc$var$queue.push(job);
    $99b18dd98d1424fc$var$queueFlush();
}
function $99b18dd98d1424fc$var$dequeueJob(job) {
    let index = $99b18dd98d1424fc$var$queue.indexOf(job);
    if (index !== -1 && index > $99b18dd98d1424fc$var$lastFlushedIndex) $99b18dd98d1424fc$var$queue.splice(index, 1);
}
function $99b18dd98d1424fc$var$queueFlush() {
    if (!$99b18dd98d1424fc$var$flushing && !$99b18dd98d1424fc$var$flushPending) {
        $99b18dd98d1424fc$var$flushPending = true;
        queueMicrotask($99b18dd98d1424fc$var$flushJobs);
    }
}
function $99b18dd98d1424fc$var$flushJobs() {
    $99b18dd98d1424fc$var$flushPending = false;
    $99b18dd98d1424fc$var$flushing = true;
    for(let i = 0; i < $99b18dd98d1424fc$var$queue.length; i++){
        $99b18dd98d1424fc$var$queue[i]();
        $99b18dd98d1424fc$var$lastFlushedIndex = i;
    }
    $99b18dd98d1424fc$var$queue.length = 0;
    $99b18dd98d1424fc$var$lastFlushedIndex = -1;
    $99b18dd98d1424fc$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $99b18dd98d1424fc$var$reactive;
var $99b18dd98d1424fc$var$effect;
var $99b18dd98d1424fc$var$release;
var $99b18dd98d1424fc$var$raw;
var $99b18dd98d1424fc$var$shouldSchedule = true;
function $99b18dd98d1424fc$var$disableEffectScheduling(callback) {
    $99b18dd98d1424fc$var$shouldSchedule = false;
    callback();
    $99b18dd98d1424fc$var$shouldSchedule = true;
}
function $99b18dd98d1424fc$var$setReactivityEngine(engine) {
    $99b18dd98d1424fc$var$reactive = engine.reactive;
    $99b18dd98d1424fc$var$release = engine.release;
    $99b18dd98d1424fc$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($99b18dd98d1424fc$var$shouldSchedule) $99b18dd98d1424fc$var$scheduler(task);
                else task();
            }
        });
    $99b18dd98d1424fc$var$raw = engine.raw;
}
function $99b18dd98d1424fc$var$overrideEffect(override) {
    $99b18dd98d1424fc$var$effect = override;
}
function $99b18dd98d1424fc$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $99b18dd98d1424fc$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $99b18dd98d1424fc$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $99b18dd98d1424fc$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $99b18dd98d1424fc$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$99b18dd98d1424fc$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $99b18dd98d1424fc$var$onAttributeAddeds = [];
var $99b18dd98d1424fc$var$onElRemoveds = [];
var $99b18dd98d1424fc$var$onElAddeds = [];
function $99b18dd98d1424fc$var$onElAdded(callback) {
    $99b18dd98d1424fc$var$onElAddeds.push(callback);
}
function $99b18dd98d1424fc$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $99b18dd98d1424fc$var$onElRemoveds.push(callback);
    }
}
function $99b18dd98d1424fc$var$onAttributesAdded(callback) {
    $99b18dd98d1424fc$var$onAttributeAddeds.push(callback);
}
function $99b18dd98d1424fc$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $99b18dd98d1424fc$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $99b18dd98d1424fc$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $99b18dd98d1424fc$var$observer = new MutationObserver($99b18dd98d1424fc$var$onMutate);
var $99b18dd98d1424fc$var$currentlyObserving = false;
function $99b18dd98d1424fc$var$startObservingMutations() {
    $99b18dd98d1424fc$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $99b18dd98d1424fc$var$currentlyObserving = true;
}
function $99b18dd98d1424fc$var$stopObservingMutations() {
    $99b18dd98d1424fc$var$flushObserver();
    $99b18dd98d1424fc$var$observer.disconnect();
    $99b18dd98d1424fc$var$currentlyObserving = false;
}
var $99b18dd98d1424fc$var$queuedMutations = [];
function $99b18dd98d1424fc$var$flushObserver() {
    let records = $99b18dd98d1424fc$var$observer.takeRecords();
    $99b18dd98d1424fc$var$queuedMutations.push(()=>records.length > 0 && $99b18dd98d1424fc$var$onMutate(records));
    let queueLengthWhenTriggered = $99b18dd98d1424fc$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($99b18dd98d1424fc$var$queuedMutations.length === queueLengthWhenTriggered) while($99b18dd98d1424fc$var$queuedMutations.length > 0)$99b18dd98d1424fc$var$queuedMutations.shift()();
    });
}
function $99b18dd98d1424fc$var$mutateDom(callback) {
    if (!$99b18dd98d1424fc$var$currentlyObserving) return callback();
    $99b18dd98d1424fc$var$stopObservingMutations();
    let result = callback();
    $99b18dd98d1424fc$var$startObservingMutations();
    return result;
}
var $99b18dd98d1424fc$var$isCollecting = false;
var $99b18dd98d1424fc$var$deferredMutations = [];
function $99b18dd98d1424fc$var$deferMutations() {
    $99b18dd98d1424fc$var$isCollecting = true;
}
function $99b18dd98d1424fc$var$flushAndStopDeferringMutations() {
    $99b18dd98d1424fc$var$isCollecting = false;
    $99b18dd98d1424fc$var$onMutate($99b18dd98d1424fc$var$deferredMutations);
    $99b18dd98d1424fc$var$deferredMutations = [];
}
function $99b18dd98d1424fc$var$onMutate(mutations) {
    if ($99b18dd98d1424fc$var$isCollecting) {
        $99b18dd98d1424fc$var$deferredMutations = $99b18dd98d1424fc$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $99b18dd98d1424fc$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $99b18dd98d1424fc$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $99b18dd98d1424fc$var$onElRemoveds.forEach((i)=>i(node));
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $99b18dd98d1424fc$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $99b18dd98d1424fc$var$scope(node) {
    return $99b18dd98d1424fc$var$mergeProxies($99b18dd98d1424fc$var$closestDataStack(node));
}
function $99b18dd98d1424fc$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$99b18dd98d1424fc$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $99b18dd98d1424fc$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $99b18dd98d1424fc$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $99b18dd98d1424fc$var$closestDataStack(node.parentNode);
}
function $99b18dd98d1424fc$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $99b18dd98d1424fc$var$mergeProxyTrap);
}
var $99b18dd98d1424fc$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $99b18dd98d1424fc$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $99b18dd98d1424fc$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $99b18dd98d1424fc$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $99b18dd98d1424fc$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$99b18dd98d1424fc$var$get(data2, path), (value)=>$99b18dd98d1424fc$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $99b18dd98d1424fc$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $99b18dd98d1424fc$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $99b18dd98d1424fc$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $99b18dd98d1424fc$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $99b18dd98d1424fc$var$magics = {};
function $99b18dd98d1424fc$var$magic(name, callback) {
    $99b18dd98d1424fc$var$magics[name] = callback;
}
function $99b18dd98d1424fc$var$injectMagics(obj, el) {
    Object.entries($99b18dd98d1424fc$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $99b18dd98d1424fc$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $99b18dd98d1424fc$var$interceptor,
                    ...utilities
                };
                $99b18dd98d1424fc$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $99b18dd98d1424fc$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $99b18dd98d1424fc$var$handleError(e, el, expression);
    }
}
function $99b18dd98d1424fc$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = true;
function $99b18dd98d1424fc$var$dontAutoEvaluateFunctions(callback) {
    let cache = $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions;
    $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $99b18dd98d1424fc$var$evaluate(el, expression, extras = {}) {
    let result;
    $99b18dd98d1424fc$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $99b18dd98d1424fc$var$evaluateLater(...args) {
    return $99b18dd98d1424fc$var$theEvaluatorFunction(...args);
}
var $99b18dd98d1424fc$var$theEvaluatorFunction = $99b18dd98d1424fc$var$normalEvaluator;
function $99b18dd98d1424fc$var$setEvaluator(newEvaluator) {
    $99b18dd98d1424fc$var$theEvaluatorFunction = newEvaluator;
}
function $99b18dd98d1424fc$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $99b18dd98d1424fc$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$99b18dd98d1424fc$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $99b18dd98d1424fc$var$generateEvaluatorFromFunction(dataStack, expression) : $99b18dd98d1424fc$var$generateEvaluatorFromString(dataStack, expression, el);
    return $99b18dd98d1424fc$var$tryCatch.bind(null, el, expression, evaluator);
}
function $99b18dd98d1424fc$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($99b18dd98d1424fc$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, result);
    };
}
var $99b18dd98d1424fc$var$evaluatorMemo = {};
function $99b18dd98d1424fc$var$generateFunctionFromString(expression, el) {
    if ($99b18dd98d1424fc$var$evaluatorMemo[expression]) return $99b18dd98d1424fc$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $99b18dd98d1424fc$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $99b18dd98d1424fc$var$evaluatorMemo[expression] = func;
    return func;
}
function $99b18dd98d1424fc$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $99b18dd98d1424fc$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $99b18dd98d1424fc$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, expression));
            if (func.finished) {
                $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($99b18dd98d1424fc$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $99b18dd98d1424fc$var$prefixAsString = "x-";
function $99b18dd98d1424fc$var$prefix(subject = "") {
    return $99b18dd98d1424fc$var$prefixAsString + subject;
}
function $99b18dd98d1424fc$var$setPrefix(newPrefix) {
    $99b18dd98d1424fc$var$prefixAsString = newPrefix;
}
var $99b18dd98d1424fc$var$directiveHandlers = {};
function $99b18dd98d1424fc$var$directive(name, callback) {
    $99b18dd98d1424fc$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$99b18dd98d1424fc$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $99b18dd98d1424fc$var$directiveOrder.indexOf(directive2);
            $99b18dd98d1424fc$var$directiveOrder.splice(pos >= 0 ? pos : $99b18dd98d1424fc$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $99b18dd98d1424fc$var$directiveExists(name) {
    return Object.keys($99b18dd98d1424fc$var$directiveHandlers).includes(name);
}
function $99b18dd98d1424fc$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $99b18dd98d1424fc$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($99b18dd98d1424fc$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($99b18dd98d1424fc$var$outNonAlpineAttributes).map($99b18dd98d1424fc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($99b18dd98d1424fc$var$byPriority);
    return directives2.map((directive2)=>{
        return $99b18dd98d1424fc$var$getDirectiveHandler(el, directive2);
    });
}
function $99b18dd98d1424fc$var$attributesOnly(attributes) {
    return Array.from(attributes).map($99b18dd98d1424fc$var$toTransformedAttributes()).filter((attr)=>!$99b18dd98d1424fc$var$outNonAlpineAttributes(attr));
}
var $99b18dd98d1424fc$var$isDeferringHandlers = false;
var $99b18dd98d1424fc$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $99b18dd98d1424fc$var$currentHandlerStackKey = Symbol();
function $99b18dd98d1424fc$var$deferHandlingDirectives(callback) {
    $99b18dd98d1424fc$var$isDeferringHandlers = true;
    let key = Symbol();
    $99b18dd98d1424fc$var$currentHandlerStackKey = key;
    $99b18dd98d1424fc$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($99b18dd98d1424fc$var$directiveHandlerStacks.get(key).length)$99b18dd98d1424fc$var$directiveHandlerStacks.get(key).shift()();
        $99b18dd98d1424fc$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $99b18dd98d1424fc$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $99b18dd98d1424fc$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $99b18dd98d1424fc$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $99b18dd98d1424fc$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $99b18dd98d1424fc$var$evaluateLater.bind($99b18dd98d1424fc$var$evaluateLater, el),
        evaluate: $99b18dd98d1424fc$var$evaluate.bind($99b18dd98d1424fc$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $99b18dd98d1424fc$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $99b18dd98d1424fc$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $99b18dd98d1424fc$var$getElementBoundUtilities(el);
    $99b18dd98d1424fc$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $99b18dd98d1424fc$var$isDeferringHandlers ? $99b18dd98d1424fc$var$directiveHandlerStacks.get($99b18dd98d1424fc$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $99b18dd98d1424fc$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $99b18dd98d1424fc$var$into = (i)=>i;
function $99b18dd98d1424fc$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $99b18dd98d1424fc$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $99b18dd98d1424fc$var$attributeTransformers = [];
function $99b18dd98d1424fc$var$mapAttributes(callback) {
    $99b18dd98d1424fc$var$attributeTransformers.push(callback);
}
function $99b18dd98d1424fc$var$outNonAlpineAttributes({ name: name }) {
    return $99b18dd98d1424fc$var$alpineAttributeRegex().test(name);
}
var $99b18dd98d1424fc$var$alpineAttributeRegex = ()=>new RegExp(`^${$99b18dd98d1424fc$var$prefixAsString}([^:^.]+)\\b`);
function $99b18dd98d1424fc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($99b18dd98d1424fc$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $99b18dd98d1424fc$var$DEFAULT = "DEFAULT";
var $99b18dd98d1424fc$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $99b18dd98d1424fc$var$DEFAULT,
    "teleport"
];
function $99b18dd98d1424fc$var$byPriority(a, b) {
    let typeA = $99b18dd98d1424fc$var$directiveOrder.indexOf(a.type) === -1 ? $99b18dd98d1424fc$var$DEFAULT : a.type;
    let typeB = $99b18dd98d1424fc$var$directiveOrder.indexOf(b.type) === -1 ? $99b18dd98d1424fc$var$DEFAULT : b.type;
    return $99b18dd98d1424fc$var$directiveOrder.indexOf(typeA) - $99b18dd98d1424fc$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $99b18dd98d1424fc$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $99b18dd98d1424fc$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$99b18dd98d1424fc$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $99b18dd98d1424fc$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $99b18dd98d1424fc$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $99b18dd98d1424fc$var$started = false;
function $99b18dd98d1424fc$var$start() {
    if ($99b18dd98d1424fc$var$started) $99b18dd98d1424fc$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $99b18dd98d1424fc$var$started = true;
    if (!document.body) $99b18dd98d1424fc$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $99b18dd98d1424fc$var$dispatch(document, "alpine:init");
    $99b18dd98d1424fc$var$dispatch(document, "alpine:initializing");
    $99b18dd98d1424fc$var$startObservingMutations();
    $99b18dd98d1424fc$var$onElAdded((el)=>$99b18dd98d1424fc$var$initTree(el, $99b18dd98d1424fc$var$walk));
    $99b18dd98d1424fc$var$onElRemoved((el)=>$99b18dd98d1424fc$var$destroyTree(el));
    $99b18dd98d1424fc$var$onAttributesAdded((el, attrs)=>{
        $99b18dd98d1424fc$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$99b18dd98d1424fc$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($99b18dd98d1424fc$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $99b18dd98d1424fc$var$initTree(el);
    });
    $99b18dd98d1424fc$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $99b18dd98d1424fc$var$warnAboutMissingPlugins();
    });
}
var $99b18dd98d1424fc$var$rootSelectorCallbacks = [];
var $99b18dd98d1424fc$var$initSelectorCallbacks = [];
function $99b18dd98d1424fc$var$rootSelectors() {
    return $99b18dd98d1424fc$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $99b18dd98d1424fc$var$allSelectors() {
    return $99b18dd98d1424fc$var$rootSelectorCallbacks.concat($99b18dd98d1424fc$var$initSelectorCallbacks).map((fn)=>fn());
}
function $99b18dd98d1424fc$var$addRootSelector(selectorCallback) {
    $99b18dd98d1424fc$var$rootSelectorCallbacks.push(selectorCallback);
}
function $99b18dd98d1424fc$var$addInitSelector(selectorCallback) {
    $99b18dd98d1424fc$var$initSelectorCallbacks.push(selectorCallback);
}
function $99b18dd98d1424fc$var$closestRoot(el, includeInitSelectors = false) {
    return $99b18dd98d1424fc$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $99b18dd98d1424fc$var$allSelectors() : $99b18dd98d1424fc$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $99b18dd98d1424fc$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $99b18dd98d1424fc$var$findClosest(el.parentElement, callback);
}
function $99b18dd98d1424fc$var$isRoot(el) {
    return $99b18dd98d1424fc$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $99b18dd98d1424fc$var$initInterceptors2 = [];
function $99b18dd98d1424fc$var$interceptInit(callback) {
    $99b18dd98d1424fc$var$initInterceptors2.push(callback);
}
function $99b18dd98d1424fc$var$initTree(el, walker = $99b18dd98d1424fc$var$walk, intercept = ()=>{}) {
    $99b18dd98d1424fc$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $99b18dd98d1424fc$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $99b18dd98d1424fc$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $99b18dd98d1424fc$var$destroyTree(root, walker = $99b18dd98d1424fc$var$walk) {
    walker(root, (el)=>{
        $99b18dd98d1424fc$var$cleanupAttributes(el);
        $99b18dd98d1424fc$var$cleanupElement(el);
    });
}
function $99b18dd98d1424fc$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($99b18dd98d1424fc$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $99b18dd98d1424fc$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $99b18dd98d1424fc$var$tickStack = [];
var $99b18dd98d1424fc$var$isHolding = false;
function $99b18dd98d1424fc$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $99b18dd98d1424fc$var$isHolding || setTimeout(()=>{
            $99b18dd98d1424fc$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $99b18dd98d1424fc$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $99b18dd98d1424fc$var$releaseNextTicks() {
    $99b18dd98d1424fc$var$isHolding = false;
    while($99b18dd98d1424fc$var$tickStack.length)$99b18dd98d1424fc$var$tickStack.shift()();
}
function $99b18dd98d1424fc$var$holdNextTicks() {
    $99b18dd98d1424fc$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $99b18dd98d1424fc$var$setClasses(el, value) {
    if (Array.isArray(value)) return $99b18dd98d1424fc$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $99b18dd98d1424fc$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $99b18dd98d1424fc$var$setClasses(el, value());
    return $99b18dd98d1424fc$var$setClassesFromString(el, value);
}
function $99b18dd98d1424fc$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $99b18dd98d1424fc$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $99b18dd98d1424fc$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $99b18dd98d1424fc$var$setStylesFromObject(el, value);
    return $99b18dd98d1424fc$var$setStylesFromString(el, value);
}
function $99b18dd98d1424fc$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $99b18dd98d1424fc$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $99b18dd98d1424fc$var$setStyles(el, previousStyles);
    };
}
function $99b18dd98d1424fc$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $99b18dd98d1424fc$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $99b18dd98d1424fc$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$99b18dd98d1424fc$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $99b18dd98d1424fc$var$registerTransitionsFromHelper(el, modifiers, value);
    else $99b18dd98d1424fc$var$registerTransitionsFromClassString(el, expression, value);
});
function $99b18dd98d1424fc$var$registerTransitionsFromClassString(el, classString, stage) {
    $99b18dd98d1424fc$var$registerTransitionObject(el, $99b18dd98d1424fc$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $99b18dd98d1424fc$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $99b18dd98d1424fc$var$registerTransitionObject(el, $99b18dd98d1424fc$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $99b18dd98d1424fc$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $99b18dd98d1424fc$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $99b18dd98d1424fc$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $99b18dd98d1424fc$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $99b18dd98d1424fc$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $99b18dd98d1424fc$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $99b18dd98d1424fc$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $99b18dd98d1424fc$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $99b18dd98d1424fc$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $99b18dd98d1424fc$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $99b18dd98d1424fc$var$closestHide(parent);
}
function $99b18dd98d1424fc$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $99b18dd98d1424fc$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $99b18dd98d1424fc$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $99b18dd98d1424fc$var$once(()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $99b18dd98d1424fc$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $99b18dd98d1424fc$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $99b18dd98d1424fc$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $99b18dd98d1424fc$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $99b18dd98d1424fc$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $99b18dd98d1424fc$var$mutateDom(()=>{
                stages.end();
            });
            $99b18dd98d1424fc$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $99b18dd98d1424fc$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $99b18dd98d1424fc$var$isCloning = false;
function $99b18dd98d1424fc$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$99b18dd98d1424fc$var$isCloning ? fallback(...args) : callback(...args);
}
function $99b18dd98d1424fc$var$onlyDuringClone(callback) {
    return (...args)=>$99b18dd98d1424fc$var$isCloning && callback(...args);
}
var $99b18dd98d1424fc$var$interceptors = [];
function $99b18dd98d1424fc$var$interceptClone(callback) {
    $99b18dd98d1424fc$var$interceptors.push(callback);
}
function $99b18dd98d1424fc$var$cloneNode(from, to) {
    $99b18dd98d1424fc$var$interceptors.forEach((i)=>i(from, to));
    $99b18dd98d1424fc$var$isCloning = true;
    $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(()=>{
        $99b18dd98d1424fc$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $99b18dd98d1424fc$var$isCloning = false;
}
var $99b18dd98d1424fc$var$isCloningLegacy = false;
function $99b18dd98d1424fc$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $99b18dd98d1424fc$var$isCloning = true;
    $99b18dd98d1424fc$var$isCloningLegacy = true;
    $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(()=>{
        $99b18dd98d1424fc$var$cloneTree(newEl);
    });
    $99b18dd98d1424fc$var$isCloning = false;
    $99b18dd98d1424fc$var$isCloningLegacy = false;
}
function $99b18dd98d1424fc$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $99b18dd98d1424fc$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $99b18dd98d1424fc$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $99b18dd98d1424fc$var$initTree(el, shallowWalker);
}
function $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $99b18dd98d1424fc$var$effect;
    $99b18dd98d1424fc$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $99b18dd98d1424fc$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $99b18dd98d1424fc$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $99b18dd98d1424fc$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $99b18dd98d1424fc$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $99b18dd98d1424fc$var$camelCase(name) : name;
    switch(name){
        case "value":
            $99b18dd98d1424fc$var$bindInputValue(el, value);
            break;
        case "style":
            $99b18dd98d1424fc$var$bindStyles(el, value);
            break;
        case "class":
            $99b18dd98d1424fc$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $99b18dd98d1424fc$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $99b18dd98d1424fc$var$bindAttribute(el, name, value);
            break;
    }
}
function $99b18dd98d1424fc$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $99b18dd98d1424fc$var$safeParseBoolean(el.value) === value;
            else el.checked = $99b18dd98d1424fc$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$99b18dd98d1424fc$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $99b18dd98d1424fc$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $99b18dd98d1424fc$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $99b18dd98d1424fc$var$setClasses(el, value);
}
function $99b18dd98d1424fc$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $99b18dd98d1424fc$var$setStyles(el, value);
}
function $99b18dd98d1424fc$var$bindAttributeAndProperty(el, name, value) {
    $99b18dd98d1424fc$var$bindAttribute(el, name, value);
    $99b18dd98d1424fc$var$setPropertyIfChanged(el, name, value);
}
function $99b18dd98d1424fc$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $99b18dd98d1424fc$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($99b18dd98d1424fc$var$isBooleanAttr(name)) value = name;
        $99b18dd98d1424fc$var$setIfChanged(el, name, value);
    }
}
function $99b18dd98d1424fc$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $99b18dd98d1424fc$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $99b18dd98d1424fc$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $99b18dd98d1424fc$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $99b18dd98d1424fc$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $99b18dd98d1424fc$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $99b18dd98d1424fc$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $99b18dd98d1424fc$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $99b18dd98d1424fc$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback);
}
function $99b18dd98d1424fc$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $99b18dd98d1424fc$var$dontAutoEvaluateFunctions(()=>{
            return $99b18dd98d1424fc$var$evaluate(el, binding.expression);
        });
    }
    return $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback);
}
function $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($99b18dd98d1424fc$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $99b18dd98d1424fc$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $99b18dd98d1424fc$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $99b18dd98d1424fc$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $99b18dd98d1424fc$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($99b18dd98d1424fc$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($99b18dd98d1424fc$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($99b18dd98d1424fc$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $99b18dd98d1424fc$var$release(reference);
    };
}
function $99b18dd98d1424fc$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $99b18dd98d1424fc$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($99b18dd98d1424fc$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $99b18dd98d1424fc$var$stores = {};
var $99b18dd98d1424fc$var$isReactive = false;
function $99b18dd98d1424fc$var$store(name, value) {
    if (!$99b18dd98d1424fc$var$isReactive) {
        $99b18dd98d1424fc$var$stores = $99b18dd98d1424fc$var$reactive($99b18dd98d1424fc$var$stores);
        $99b18dd98d1424fc$var$isReactive = true;
    }
    if (value === void 0) return $99b18dd98d1424fc$var$stores[name];
    $99b18dd98d1424fc$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $99b18dd98d1424fc$var$stores[name].init();
    $99b18dd98d1424fc$var$initInterceptors($99b18dd98d1424fc$var$stores[name]);
}
function $99b18dd98d1424fc$var$getStores() {
    return $99b18dd98d1424fc$var$stores;
}
// packages/alpinejs/src/binds.js
var $99b18dd98d1424fc$var$binds = {};
function $99b18dd98d1424fc$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $99b18dd98d1424fc$var$applyBindingsObject(name, getBindings());
    else $99b18dd98d1424fc$var$binds[name] = getBindings;
    return ()=>{};
}
function $99b18dd98d1424fc$var$injectBindingProviders(obj) {
    Object.entries($99b18dd98d1424fc$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $99b18dd98d1424fc$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $99b18dd98d1424fc$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $99b18dd98d1424fc$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $99b18dd98d1424fc$var$datas = {};
function $99b18dd98d1424fc$var$data(name, callback) {
    $99b18dd98d1424fc$var$datas[name] = callback;
}
function $99b18dd98d1424fc$var$injectDataProviders(obj, context) {
    Object.entries($99b18dd98d1424fc$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $99b18dd98d1424fc$var$Alpine = {
    get reactive () {
        return $99b18dd98d1424fc$var$reactive;
    },
    get release () {
        return $99b18dd98d1424fc$var$release;
    },
    get effect () {
        return $99b18dd98d1424fc$var$effect;
    },
    get raw () {
        return $99b18dd98d1424fc$var$raw;
    },
    version: "3.14.1",
    flushAndStopDeferringMutations: $99b18dd98d1424fc$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $99b18dd98d1424fc$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $99b18dd98d1424fc$var$disableEffectScheduling,
    startObservingMutations: $99b18dd98d1424fc$var$startObservingMutations,
    stopObservingMutations: $99b18dd98d1424fc$var$stopObservingMutations,
    setReactivityEngine: $99b18dd98d1424fc$var$setReactivityEngine,
    onAttributeRemoved: $99b18dd98d1424fc$var$onAttributeRemoved,
    onAttributesAdded: $99b18dd98d1424fc$var$onAttributesAdded,
    closestDataStack: $99b18dd98d1424fc$var$closestDataStack,
    skipDuringClone: $99b18dd98d1424fc$var$skipDuringClone,
    onlyDuringClone: $99b18dd98d1424fc$var$onlyDuringClone,
    addRootSelector: $99b18dd98d1424fc$var$addRootSelector,
    addInitSelector: $99b18dd98d1424fc$var$addInitSelector,
    interceptClone: $99b18dd98d1424fc$var$interceptClone,
    addScopeToNode: $99b18dd98d1424fc$var$addScopeToNode,
    deferMutations: $99b18dd98d1424fc$var$deferMutations,
    mapAttributes: $99b18dd98d1424fc$var$mapAttributes,
    evaluateLater: $99b18dd98d1424fc$var$evaluateLater,
    interceptInit: $99b18dd98d1424fc$var$interceptInit,
    setEvaluator: $99b18dd98d1424fc$var$setEvaluator,
    mergeProxies: $99b18dd98d1424fc$var$mergeProxies,
    extractProp: $99b18dd98d1424fc$var$extractProp,
    findClosest: $99b18dd98d1424fc$var$findClosest,
    onElRemoved: $99b18dd98d1424fc$var$onElRemoved,
    closestRoot: $99b18dd98d1424fc$var$closestRoot,
    destroyTree: $99b18dd98d1424fc$var$destroyTree,
    interceptor: $99b18dd98d1424fc$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $99b18dd98d1424fc$var$transition,
    setStyles: // INTERNAL
    $99b18dd98d1424fc$var$setStyles,
    mutateDom: // INTERNAL
    $99b18dd98d1424fc$var$mutateDom,
    directive: $99b18dd98d1424fc$var$directive,
    entangle: $99b18dd98d1424fc$var$entangle,
    throttle: $99b18dd98d1424fc$var$throttle,
    debounce: $99b18dd98d1424fc$var$debounce,
    evaluate: $99b18dd98d1424fc$var$evaluate,
    initTree: $99b18dd98d1424fc$var$initTree,
    nextTick: $99b18dd98d1424fc$var$nextTick,
    prefixed: $99b18dd98d1424fc$var$prefix,
    prefix: $99b18dd98d1424fc$var$setPrefix,
    plugin: $99b18dd98d1424fc$var$plugin,
    magic: $99b18dd98d1424fc$var$magic,
    store: $99b18dd98d1424fc$var$store,
    start: $99b18dd98d1424fc$var$start,
    clone: $99b18dd98d1424fc$var$clone,
    cloneNode: // INTERNAL
    $99b18dd98d1424fc$var$cloneNode,
    // INTERNAL
    bound: $99b18dd98d1424fc$var$getBinding,
    $data: $99b18dd98d1424fc$var$scope,
    watch: $99b18dd98d1424fc$var$watch,
    walk: $99b18dd98d1424fc$var$walk,
    data: $99b18dd98d1424fc$var$data,
    bind: $99b18dd98d1424fc$var$bind2
};
var $99b18dd98d1424fc$var$alpine_default = $99b18dd98d1424fc$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $99b18dd98d1424fc$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $99b18dd98d1424fc$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $99b18dd98d1424fc$var$isBooleanAttr2 = /* @__PURE__ */ $99b18dd98d1424fc$var$makeMap($99b18dd98d1424fc$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $99b18dd98d1424fc$var$EMPTY_OBJ = Object.freeze({});
var $99b18dd98d1424fc$var$EMPTY_ARR = Object.freeze([]);
var $99b18dd98d1424fc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $99b18dd98d1424fc$var$hasOwn = (val, key)=>$99b18dd98d1424fc$var$hasOwnProperty.call(val, key);
var $99b18dd98d1424fc$var$isArray = Array.isArray;
var $99b18dd98d1424fc$var$isMap = (val)=>$99b18dd98d1424fc$var$toTypeString(val) === "[object Map]";
var $99b18dd98d1424fc$var$isString = (val)=>typeof val === "string";
var $99b18dd98d1424fc$var$isSymbol = (val)=>typeof val === "symbol";
var $99b18dd98d1424fc$var$isObject = (val)=>val !== null && typeof val === "object";
var $99b18dd98d1424fc$var$objectToString = Object.prototype.toString;
var $99b18dd98d1424fc$var$toTypeString = (value)=>$99b18dd98d1424fc$var$objectToString.call(value);
var $99b18dd98d1424fc$var$toRawType = (value)=>{
    return $99b18dd98d1424fc$var$toTypeString(value).slice(8, -1);
};
var $99b18dd98d1424fc$var$isIntegerKey = (key)=>$99b18dd98d1424fc$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $99b18dd98d1424fc$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $99b18dd98d1424fc$var$camelizeRE = /-(\w)/g;
var $99b18dd98d1424fc$var$camelize = $99b18dd98d1424fc$var$cacheStringFunction((str)=>{
    return str.replace($99b18dd98d1424fc$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $99b18dd98d1424fc$var$hyphenateRE = /\B([A-Z])/g;
var $99b18dd98d1424fc$var$hyphenate = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str.replace($99b18dd98d1424fc$var$hyphenateRE, "-$1").toLowerCase());
var $99b18dd98d1424fc$var$capitalize = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $99b18dd98d1424fc$var$toHandlerKey = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str ? `on${$99b18dd98d1424fc$var$capitalize(str)}` : ``);
var $99b18dd98d1424fc$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $99b18dd98d1424fc$var$targetMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$effectStack = [];
var $99b18dd98d1424fc$var$activeEffect;
var $99b18dd98d1424fc$var$ITERATE_KEY = Symbol("iterate");
var $99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $99b18dd98d1424fc$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $99b18dd98d1424fc$var$effect2(fn, options = $99b18dd98d1424fc$var$EMPTY_OBJ) {
    if ($99b18dd98d1424fc$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $99b18dd98d1424fc$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $99b18dd98d1424fc$var$stop(effect3) {
    if (effect3.active) {
        $99b18dd98d1424fc$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $99b18dd98d1424fc$var$uid = 0;
function $99b18dd98d1424fc$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$99b18dd98d1424fc$var$effectStack.includes(effect3)) {
            $99b18dd98d1424fc$var$cleanup(effect3);
            try {
                $99b18dd98d1424fc$var$enableTracking();
                $99b18dd98d1424fc$var$effectStack.push(effect3);
                $99b18dd98d1424fc$var$activeEffect = effect3;
                return fn();
            } finally{
                $99b18dd98d1424fc$var$effectStack.pop();
                $99b18dd98d1424fc$var$resetTracking();
                $99b18dd98d1424fc$var$activeEffect = $99b18dd98d1424fc$var$effectStack[$99b18dd98d1424fc$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $99b18dd98d1424fc$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $99b18dd98d1424fc$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $99b18dd98d1424fc$var$shouldTrack = true;
var $99b18dd98d1424fc$var$trackStack = [];
function $99b18dd98d1424fc$var$pauseTracking() {
    $99b18dd98d1424fc$var$trackStack.push($99b18dd98d1424fc$var$shouldTrack);
    $99b18dd98d1424fc$var$shouldTrack = false;
}
function $99b18dd98d1424fc$var$enableTracking() {
    $99b18dd98d1424fc$var$trackStack.push($99b18dd98d1424fc$var$shouldTrack);
    $99b18dd98d1424fc$var$shouldTrack = true;
}
function $99b18dd98d1424fc$var$resetTracking() {
    const last = $99b18dd98d1424fc$var$trackStack.pop();
    $99b18dd98d1424fc$var$shouldTrack = last === void 0 ? true : last;
}
function $99b18dd98d1424fc$var$track(target, type, key) {
    if (!$99b18dd98d1424fc$var$shouldTrack || $99b18dd98d1424fc$var$activeEffect === void 0) return;
    let depsMap = $99b18dd98d1424fc$var$targetMap.get(target);
    if (!depsMap) $99b18dd98d1424fc$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($99b18dd98d1424fc$var$activeEffect)) {
        dep.add($99b18dd98d1424fc$var$activeEffect);
        $99b18dd98d1424fc$var$activeEffect.deps.push(dep);
        if ($99b18dd98d1424fc$var$activeEffect.options.onTrack) $99b18dd98d1424fc$var$activeEffect.options.onTrack({
            effect: $99b18dd98d1424fc$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $99b18dd98d1424fc$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $99b18dd98d1424fc$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $99b18dd98d1424fc$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $99b18dd98d1424fc$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$99b18dd98d1424fc$var$isArray(target)) {
                    add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                    if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY));
                } else if ($99b18dd98d1424fc$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$99b18dd98d1424fc$var$isArray(target)) {
                    add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                    if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $99b18dd98d1424fc$var$isNonTrackableKeys = /* @__PURE__ */ $99b18dd98d1424fc$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $99b18dd98d1424fc$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($99b18dd98d1424fc$var$isSymbol));
var $99b18dd98d1424fc$var$get2 = /* @__PURE__ */ $99b18dd98d1424fc$var$createGetter();
var $99b18dd98d1424fc$var$readonlyGet = /* @__PURE__ */ $99b18dd98d1424fc$var$createGetter(true);
var $99b18dd98d1424fc$var$arrayInstrumentations = /* @__PURE__ */ $99b18dd98d1424fc$var$createArrayInstrumentations();
function $99b18dd98d1424fc$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $99b18dd98d1424fc$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$99b18dd98d1424fc$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($99b18dd98d1424fc$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $99b18dd98d1424fc$var$pauseTracking();
            const res = $99b18dd98d1424fc$var$toRaw(this)[key].apply(this, args);
            $99b18dd98d1424fc$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $99b18dd98d1424fc$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $99b18dd98d1424fc$var$shallowReadonlyMap : $99b18dd98d1424fc$var$readonlyMap : shallow ? $99b18dd98d1424fc$var$shallowReactiveMap : $99b18dd98d1424fc$var$reactiveMap).get(target)) return target;
        const targetIsArray = $99b18dd98d1424fc$var$isArray(target);
        if (!isReadonly && targetIsArray && $99b18dd98d1424fc$var$hasOwn($99b18dd98d1424fc$var$arrayInstrumentations, key)) return Reflect.get($99b18dd98d1424fc$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($99b18dd98d1424fc$var$isSymbol(key) ? $99b18dd98d1424fc$var$builtInSymbols.has(key) : $99b18dd98d1424fc$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $99b18dd98d1424fc$var$track(target, "get", key);
        if (shallow) return res;
        if ($99b18dd98d1424fc$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$99b18dd98d1424fc$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($99b18dd98d1424fc$var$isObject(res)) return isReadonly ? $99b18dd98d1424fc$var$readonly(res) : $99b18dd98d1424fc$var$reactive2(res);
        return res;
    };
}
var $99b18dd98d1424fc$var$set2 = /* @__PURE__ */ $99b18dd98d1424fc$var$createSetter();
function $99b18dd98d1424fc$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $99b18dd98d1424fc$var$toRaw(value);
            oldValue = $99b18dd98d1424fc$var$toRaw(oldValue);
            if (!$99b18dd98d1424fc$var$isArray(target) && $99b18dd98d1424fc$var$isRef(oldValue) && !$99b18dd98d1424fc$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $99b18dd98d1424fc$var$isArray(target) && $99b18dd98d1424fc$var$isIntegerKey(key) ? Number(key) < target.length : $99b18dd98d1424fc$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $99b18dd98d1424fc$var$toRaw(receiver)) {
            if (!hadKey) $99b18dd98d1424fc$var$trigger(target, "add", key, value);
            else if ($99b18dd98d1424fc$var$hasChanged(value, oldValue)) $99b18dd98d1424fc$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $99b18dd98d1424fc$var$deleteProperty(target, key) {
    const hadKey = $99b18dd98d1424fc$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $99b18dd98d1424fc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $99b18dd98d1424fc$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$99b18dd98d1424fc$var$isSymbol(key) || !$99b18dd98d1424fc$var$builtInSymbols.has(key)) $99b18dd98d1424fc$var$track(target, "has", key);
    return result;
}
function $99b18dd98d1424fc$var$ownKeys(target) {
    $99b18dd98d1424fc$var$track(target, "iterate", $99b18dd98d1424fc$var$isArray(target) ? "length" : $99b18dd98d1424fc$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $99b18dd98d1424fc$var$mutableHandlers = {
    get: $99b18dd98d1424fc$var$get2,
    set: $99b18dd98d1424fc$var$set2,
    deleteProperty: $99b18dd98d1424fc$var$deleteProperty,
    has: $99b18dd98d1424fc$var$has,
    ownKeys: $99b18dd98d1424fc$var$ownKeys
};
var $99b18dd98d1424fc$var$readonlyHandlers = {
    get: $99b18dd98d1424fc$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $99b18dd98d1424fc$var$toReactive = (value)=>$99b18dd98d1424fc$var$isObject(value) ? $99b18dd98d1424fc$var$reactive2(value) : value;
var $99b18dd98d1424fc$var$toReadonly = (value)=>$99b18dd98d1424fc$var$isObject(value) ? $99b18dd98d1424fc$var$readonly(value) : value;
var $99b18dd98d1424fc$var$toShallow = (value)=>value;
var $99b18dd98d1424fc$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $99b18dd98d1424fc$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "get", key);
    !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $99b18dd98d1424fc$var$getProto(rawTarget);
    const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $99b18dd98d1424fc$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "has", key);
    !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $99b18dd98d1424fc$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $99b18dd98d1424fc$var$track($99b18dd98d1424fc$var$toRaw(target), "iterate", $99b18dd98d1424fc$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $99b18dd98d1424fc$var$add(value) {
    value = $99b18dd98d1424fc$var$toRaw(value);
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const proto = $99b18dd98d1424fc$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $99b18dd98d1424fc$var$trigger(target, "add", value, value);
    }
    return this;
}
function $99b18dd98d1424fc$var$set$1(key, value) {
    value = $99b18dd98d1424fc$var$toRaw(value);
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const { has: has2, get: get3 } = $99b18dd98d1424fc$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $99b18dd98d1424fc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $99b18dd98d1424fc$var$trigger(target, "add", key, value);
    else if ($99b18dd98d1424fc$var$hasChanged(value, oldValue)) $99b18dd98d1424fc$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $99b18dd98d1424fc$var$deleteEntry(key) {
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const { has: has2, get: get3 } = $99b18dd98d1424fc$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $99b18dd98d1424fc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $99b18dd98d1424fc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $99b18dd98d1424fc$var$clear() {
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $99b18dd98d1424fc$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $99b18dd98d1424fc$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $99b18dd98d1424fc$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
        const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
        !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "iterate", $99b18dd98d1424fc$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $99b18dd98d1424fc$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
        const targetIsMap = $99b18dd98d1424fc$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
        !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "iterate", isKeyOnly ? $99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY : $99b18dd98d1424fc$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $99b18dd98d1424fc$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$99b18dd98d1424fc$var$capitalize(type)} operation ${key}failed: target is readonly.`, $99b18dd98d1424fc$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $99b18dd98d1424fc$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this);
        },
        has: $99b18dd98d1424fc$var$has$1,
        add: $99b18dd98d1424fc$var$add,
        set: $99b18dd98d1424fc$var$set$1,
        delete: $99b18dd98d1424fc$var$deleteEntry,
        clear: $99b18dd98d1424fc$var$clear,
        forEach: $99b18dd98d1424fc$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, false, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this);
        },
        has: $99b18dd98d1424fc$var$has$1,
        add: $99b18dd98d1424fc$var$add,
        set: $99b18dd98d1424fc$var$set$1,
        delete: $99b18dd98d1424fc$var$deleteEntry,
        clear: $99b18dd98d1424fc$var$clear,
        forEach: $99b18dd98d1424fc$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this, true);
        },
        has (key) {
            return $99b18dd98d1424fc$var$has$1.call(this, key, true);
        },
        add: $99b18dd98d1424fc$var$createReadonlyMethod("add"),
        set: $99b18dd98d1424fc$var$createReadonlyMethod("set"),
        delete: $99b18dd98d1424fc$var$createReadonlyMethod("delete"),
        clear: $99b18dd98d1424fc$var$createReadonlyMethod("clear"),
        forEach: $99b18dd98d1424fc$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, true, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this, true);
        },
        has (key) {
            return $99b18dd98d1424fc$var$has$1.call(this, key, true);
        },
        add: $99b18dd98d1424fc$var$createReadonlyMethod("add"),
        set: $99b18dd98d1424fc$var$createReadonlyMethod("set"),
        delete: $99b18dd98d1424fc$var$createReadonlyMethod("delete"),
        clear: $99b18dd98d1424fc$var$createReadonlyMethod("clear"),
        forEach: $99b18dd98d1424fc$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$99b18dd98d1424fc$var$mutableInstrumentations, $99b18dd98d1424fc$var$readonlyInstrumentations, $99b18dd98d1424fc$var$shallowInstrumentations, $99b18dd98d1424fc$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentations();
function $99b18dd98d1424fc$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $99b18dd98d1424fc$var$shallowReadonlyInstrumentations : $99b18dd98d1424fc$var$shallowInstrumentations : isReadonly ? $99b18dd98d1424fc$var$readonlyInstrumentations : $99b18dd98d1424fc$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($99b18dd98d1424fc$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $99b18dd98d1424fc$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentationGetter(false, false)
};
var $99b18dd98d1424fc$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentationGetter(true, false)
};
function $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $99b18dd98d1424fc$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $99b18dd98d1424fc$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $99b18dd98d1424fc$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $99b18dd98d1424fc$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $99b18dd98d1424fc$var$targetTypeMap($99b18dd98d1424fc$var$toRawType(value));
}
function $99b18dd98d1424fc$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $99b18dd98d1424fc$var$createReactiveObject(target, false, $99b18dd98d1424fc$var$mutableHandlers, $99b18dd98d1424fc$var$mutableCollectionHandlers, $99b18dd98d1424fc$var$reactiveMap);
}
function $99b18dd98d1424fc$var$readonly(target) {
    return $99b18dd98d1424fc$var$createReactiveObject(target, true, $99b18dd98d1424fc$var$readonlyHandlers, $99b18dd98d1424fc$var$readonlyCollectionHandlers, $99b18dd98d1424fc$var$readonlyMap);
}
function $99b18dd98d1424fc$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$99b18dd98d1424fc$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $99b18dd98d1424fc$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $99b18dd98d1424fc$var$toRaw(observed) {
    return observed && $99b18dd98d1424fc$var$toRaw(observed["__v_raw"]) || observed;
}
function $99b18dd98d1424fc$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$99b18dd98d1424fc$var$magic("nextTick", ()=>$99b18dd98d1424fc$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$99b18dd98d1424fc$var$magic("dispatch", (el)=>$99b18dd98d1424fc$var$dispatch.bind($99b18dd98d1424fc$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$99b18dd98d1424fc$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $99b18dd98d1424fc$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$99b18dd98d1424fc$var$magic("store", $99b18dd98d1424fc$var$getStores);
// packages/alpinejs/src/magics/$data.js
$99b18dd98d1424fc$var$magic("data", (el)=>$99b18dd98d1424fc$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$99b18dd98d1424fc$var$magic("root", (el)=>$99b18dd98d1424fc$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$99b18dd98d1424fc$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $99b18dd98d1424fc$var$mergeProxies($99b18dd98d1424fc$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $99b18dd98d1424fc$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $99b18dd98d1424fc$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $99b18dd98d1424fc$var$globalIdMemo = {};
function $99b18dd98d1424fc$var$findAndIncrementId(name) {
    if (!$99b18dd98d1424fc$var$globalIdMemo[name]) $99b18dd98d1424fc$var$globalIdMemo[name] = 0;
    return ++$99b18dd98d1424fc$var$globalIdMemo[name];
}
function $99b18dd98d1424fc$var$closestIdRoot(el, name) {
    return $99b18dd98d1424fc$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $99b18dd98d1424fc$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $99b18dd98d1424fc$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$99b18dd98d1424fc$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $99b18dd98d1424fc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $99b18dd98d1424fc$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $99b18dd98d1424fc$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $99b18dd98d1424fc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$99b18dd98d1424fc$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$99b18dd98d1424fc$var$warnMissingPluginMagic("Focus", "focus", "focus");
$99b18dd98d1424fc$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $99b18dd98d1424fc$var$warnMissingPluginMagic(name, magicName, slug) {
    $99b18dd98d1424fc$var$magic(magicName, (el)=>$99b18dd98d1424fc$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$99b18dd98d1424fc$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $99b18dd98d1424fc$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$99b18dd98d1424fc$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $99b18dd98d1424fc$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $99b18dd98d1424fc$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $99b18dd98d1424fc$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $99b18dd98d1424fc$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $99b18dd98d1424fc$var$skipDuringClone(()=>{
            $99b18dd98d1424fc$var$initTree(clone2);
            clone2._x_ignore = true;
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $99b18dd98d1424fc$var$getTarget(expression);
        $99b18dd98d1424fc$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $99b18dd98d1424fc$var$teleportContainerDuringClone = document.createElement("div");
function $99b18dd98d1424fc$var$getTarget(expression) {
    let target = $99b18dd98d1424fc$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $99b18dd98d1424fc$var$teleportContainerDuringClone;
    })();
    if (!target) $99b18dd98d1424fc$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $99b18dd98d1424fc$var$handler = ()=>{};
$99b18dd98d1424fc$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$99b18dd98d1424fc$var$directive("ignore", $99b18dd98d1424fc$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$99b18dd98d1424fc$var$directive("effect", $99b18dd98d1424fc$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($99b18dd98d1424fc$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $99b18dd98d1424fc$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $99b18dd98d1424fc$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $99b18dd98d1424fc$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $99b18dd98d1424fc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $99b18dd98d1424fc$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $99b18dd98d1424fc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $99b18dd98d1424fc$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($99b18dd98d1424fc$var$isKeyEvent(event) || $99b18dd98d1424fc$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($99b18dd98d1424fc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $99b18dd98d1424fc$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $99b18dd98d1424fc$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $99b18dd98d1424fc$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $99b18dd98d1424fc$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $99b18dd98d1424fc$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $99b18dd98d1424fc$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $99b18dd98d1424fc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $99b18dd98d1424fc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $99b18dd98d1424fc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $99b18dd98d1424fc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($99b18dd98d1424fc$var$isClickEvent(e.type)) return false;
            if ($99b18dd98d1424fc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $99b18dd98d1424fc$var$keyToModifiers(key) {
    if (!key) return [];
    key = $99b18dd98d1424fc$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$99b18dd98d1424fc$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $99b18dd98d1424fc$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($99b18dd98d1424fc$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $99b18dd98d1424fc$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $99b18dd98d1424fc$var$isCloning ? ()=>{} : $99b18dd98d1424fc$var$on(el, event, modifiers, (e)=>{
        setValue($99b18dd98d1424fc$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($99b18dd98d1424fc$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $99b18dd98d1424fc$var$on(el.form, "reset", [], (e)=>{
            $99b18dd98d1424fc$var$nextTick(()=>el._x_model && el._x_model.set($99b18dd98d1424fc$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $99b18dd98d1424fc$var$mutateDom(()=>$99b18dd98d1424fc$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $99b18dd98d1424fc$var$getInputValue(el, modifiers, event, currentValue) {
    return $99b18dd98d1424fc$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $99b18dd98d1424fc$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $99b18dd98d1424fc$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$99b18dd98d1424fc$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $99b18dd98d1424fc$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $99b18dd98d1424fc$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if (el.type === "radio") {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $99b18dd98d1424fc$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $99b18dd98d1424fc$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $99b18dd98d1424fc$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $99b18dd98d1424fc$var$isNumeric2(number) ? number : rawValue;
}
function $99b18dd98d1424fc$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $99b18dd98d1424fc$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $99b18dd98d1424fc$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$99b18dd98d1424fc$var$directive("cloak", (el)=>queueMicrotask(()=>$99b18dd98d1424fc$var$mutateDom(()=>el.removeAttribute($99b18dd98d1424fc$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$99b18dd98d1424fc$var$addInitSelector(()=>`[${$99b18dd98d1424fc$var$prefix("init")}]`);
$99b18dd98d1424fc$var$directive("init", $99b18dd98d1424fc$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$99b18dd98d1424fc$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$99b18dd98d1424fc$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $99b18dd98d1424fc$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$99b18dd98d1424fc$var$mapAttributes($99b18dd98d1424fc$var$startingWith(":", $99b18dd98d1424fc$var$into($99b18dd98d1424fc$var$prefix("bind:"))));
var $99b18dd98d1424fc$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $99b18dd98d1424fc$var$injectBindingProviders(bindingProviders);
        let getBindings = $99b18dd98d1424fc$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $99b18dd98d1424fc$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $99b18dd98d1424fc$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $99b18dd98d1424fc$var$mutateDom(()=>$99b18dd98d1424fc$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$99b18dd98d1424fc$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$99b18dd98d1424fc$var$directive("bind", $99b18dd98d1424fc$var$handler2);
function $99b18dd98d1424fc$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$99b18dd98d1424fc$var$addRootSelector(()=>`[${$99b18dd98d1424fc$var$prefix("data")}]`);
$99b18dd98d1424fc$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($99b18dd98d1424fc$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $99b18dd98d1424fc$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $99b18dd98d1424fc$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $99b18dd98d1424fc$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $99b18dd98d1424fc$var$injectMagics(data2, el);
    let reactiveData = $99b18dd98d1424fc$var$reactive(data2);
    $99b18dd98d1424fc$var$initInterceptors(reactiveData);
    let undo = $99b18dd98d1424fc$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $99b18dd98d1424fc$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $99b18dd98d1424fc$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $99b18dd98d1424fc$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$99b18dd98d1424fc$var$isCloning) return false;
    if ($99b18dd98d1424fc$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$99b18dd98d1424fc$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $99b18dd98d1424fc$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$99b18dd98d1424fc$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $99b18dd98d1424fc$var$parseForExpression(expression);
    let evaluateItems = $99b18dd98d1424fc$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $99b18dd98d1424fc$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$99b18dd98d1424fc$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $99b18dd98d1424fc$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($99b18dd98d1424fc$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $99b18dd98d1424fc$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $99b18dd98d1424fc$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($99b18dd98d1424fc$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $99b18dd98d1424fc$var$mutateDom(()=>{
                if (!elForSpot) $99b18dd98d1424fc$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $99b18dd98d1424fc$var$reactive(scope2);
            $99b18dd98d1424fc$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $99b18dd98d1424fc$var$mutateDom(()=>{
                lastEl.after(clone2);
                $99b18dd98d1424fc$var$skipDuringClone(()=>$99b18dd98d1424fc$var$initTree(clone2))();
            });
            if (typeof key === "object") $99b18dd98d1424fc$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $99b18dd98d1424fc$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $99b18dd98d1424fc$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $99b18dd98d1424fc$var$handler3() {}
$99b18dd98d1424fc$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $99b18dd98d1424fc$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$99b18dd98d1424fc$var$directive("ref", $99b18dd98d1424fc$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$99b18dd98d1424fc$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $99b18dd98d1424fc$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $99b18dd98d1424fc$var$addScopeToNode(clone2, {}, el);
        $99b18dd98d1424fc$var$mutateDom(()=>{
            el.after(clone2);
            $99b18dd98d1424fc$var$skipDuringClone(()=>$99b18dd98d1424fc$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $99b18dd98d1424fc$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($99b18dd98d1424fc$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$99b18dd98d1424fc$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$99b18dd98d1424fc$var$setIdRoot(el, name));
});
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$99b18dd98d1424fc$var$mapAttributes($99b18dd98d1424fc$var$startingWith("@", $99b18dd98d1424fc$var$into($99b18dd98d1424fc$var$prefix("on:"))));
$99b18dd98d1424fc$var$directive("on", $99b18dd98d1424fc$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $99b18dd98d1424fc$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $99b18dd98d1424fc$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$99b18dd98d1424fc$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Focus", "trap", "focus");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $99b18dd98d1424fc$var$warnMissingPluginDirective(name, directiveName, slug) {
    $99b18dd98d1424fc$var$directive(directiveName, (el)=>$99b18dd98d1424fc$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$99b18dd98d1424fc$var$alpine_default.setEvaluator($99b18dd98d1424fc$var$normalEvaluator);
$99b18dd98d1424fc$var$alpine_default.setReactivityEngine({
    reactive: $99b18dd98d1424fc$var$reactive2,
    effect: $99b18dd98d1424fc$var$effect2,
    release: $99b18dd98d1424fc$var$stop,
    raw: $99b18dd98d1424fc$var$toRaw
});
var $99b18dd98d1424fc$export$b7ee041e4ad2afec = $99b18dd98d1424fc$var$alpine_default;
// packages/alpinejs/builds/module.js
var $99b18dd98d1424fc$export$2e2bcd8739ae039 = $99b18dd98d1424fc$export$b7ee041e4ad2afec;

});

parcelRegister("kHnZL", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $f11a6fbc065abd4a$export$bced8d2aada2d1c9; });

var $GWdd1 = parcelRequire("GWdd1");

var $9mdbq = parcelRequire("9mdbq");
// Choice: a ? b : c
const $f11a6fbc065abd4a$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $f11a6fbc065abd4a$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $f11a6fbc065abd4a$var$SHA256_K = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $f11a6fbc065abd4a$var$IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $f11a6fbc065abd4a$var$SHA256_W = new Uint32Array(64);
class $f11a6fbc065abd4a$var$SHA256 extends (0, $GWdd1.SHA2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $f11a6fbc065abd4a$var$IV[0] | 0;
        this.B = $f11a6fbc065abd4a$var$IV[1] | 0;
        this.C = $f11a6fbc065abd4a$var$IV[2] | 0;
        this.D = $f11a6fbc065abd4a$var$IV[3] | 0;
        this.E = $f11a6fbc065abd4a$var$IV[4] | 0;
        this.F = $f11a6fbc065abd4a$var$IV[5] | 0;
        this.G = $f11a6fbc065abd4a$var$IV[6] | 0;
        this.H = $f11a6fbc065abd4a$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$f11a6fbc065abd4a$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $f11a6fbc065abd4a$var$SHA256_W[i - 15];
            const W2 = $f11a6fbc065abd4a$var$SHA256_W[i - 2];
            const s0 = (0, $9mdbq.rotr)(W15, 7) ^ (0, $9mdbq.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $9mdbq.rotr)(W2, 17) ^ (0, $9mdbq.rotr)(W2, 19) ^ W2 >>> 10;
            $f11a6fbc065abd4a$var$SHA256_W[i] = s1 + $f11a6fbc065abd4a$var$SHA256_W[i - 7] + s0 + $f11a6fbc065abd4a$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $9mdbq.rotr)(E, 6) ^ (0, $9mdbq.rotr)(E, 11) ^ (0, $9mdbq.rotr)(E, 25);
            const T1 = H + sigma1 + $f11a6fbc065abd4a$var$Chi(E, F, G) + $f11a6fbc065abd4a$var$SHA256_K[i] + $f11a6fbc065abd4a$var$SHA256_W[i] | 0;
            const sigma0 = (0, $9mdbq.rotr)(A, 2) ^ (0, $9mdbq.rotr)(A, 13) ^ (0, $9mdbq.rotr)(A, 22);
            const T2 = sigma0 + $f11a6fbc065abd4a$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $f11a6fbc065abd4a$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $f11a6fbc065abd4a$var$SHA224 extends $f11a6fbc065abd4a$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $f11a6fbc065abd4a$export$bced8d2aada2d1c9 = (0, $9mdbq.wrapConstructor)(()=>new $f11a6fbc065abd4a$var$SHA256());
const $f11a6fbc065abd4a$export$97b70509d4e397ea = (0, $9mdbq.wrapConstructor)(()=>new $f11a6fbc065abd4a$var$SHA224());

});
parcelRegister("GWdd1", function(module, exports) {

$parcel$export(module.exports, "SHA2", function () { return $0811140f03d50e93$export$ebbe38f24b9a0856; });

var $kW2j6 = parcelRequire("kW2j6");

var $9mdbq = parcelRequire("9mdbq");
// Polyfill for Safari 14
function $0811140f03d50e93$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $0811140f03d50e93$export$ebbe38f24b9a0856 extends (0, $9mdbq.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $9mdbq.createView)(this.buffer);
    }
    update(data) {
        (0, $kW2j6.default).exists(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $9mdbq.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $9mdbq.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $kW2j6.default).exists(this);
        (0, $kW2j6.default).output(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $0811140f03d50e93$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $9mdbq.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});
parcelRegister("kW2j6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3db038be156b7eb$export$2e2bcd8739ae039; });
function $f3db038be156b7eb$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $f3db038be156b7eb$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
function $f3db038be156b7eb$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $f3db038be156b7eb$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $f3db038be156b7eb$export$98e628dec113755e(hash.outputLen);
    $f3db038be156b7eb$export$98e628dec113755e(hash.blockLen);
}
function $f3db038be156b7eb$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $f3db038be156b7eb$export$c789db2c85949867(out, instance) {
    $f3db038be156b7eb$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $f3db038be156b7eb$var$assert = {
    number: $f3db038be156b7eb$export$98e628dec113755e,
    bool: $f3db038be156b7eb$export$87b259aa03e3d267,
    bytes: $f3db038be156b7eb$export$b3317979f9250576,
    hash: $f3db038be156b7eb$export$d6af199866bfb566,
    exists: $f3db038be156b7eb$export$f7e9f41ea797a17,
    output: $f3db038be156b7eb$export$c789db2c85949867
};
var $f3db038be156b7eb$export$2e2bcd8739ae039 = $f3db038be156b7eb$var$assert;

});

parcelRegister("9mdbq", function(module, exports) {

$parcel$export(module.exports, "createView", function () { return $6d0065097d5215bf$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $6d0065097d5215bf$export$466993d7d0d272aa; });
$parcel$export(module.exports, "bytesToHex", function () { return $6d0065097d5215bf$export$58b867e287a802c8; });
$parcel$export(module.exports, "hexToBytes", function () { return $6d0065097d5215bf$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "toBytes", function () { return $6d0065097d5215bf$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $6d0065097d5215bf$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $6d0065097d5215bf$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $6d0065097d5215bf$export$f081816339df1972; });
$parcel$export(module.exports, "randomBytes", function () { return $6d0065097d5215bf$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.

var $9hV6m = parcelRequire("9hV6m");
const $6d0065097d5215bf$var$u8a = (a)=>a instanceof Uint8Array;
const $6d0065097d5215bf$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $6d0065097d5215bf$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $6d0065097d5215bf$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $6d0065097d5215bf$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $6d0065097d5215bf$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$6d0065097d5215bf$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
const $6d0065097d5215bf$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
function $6d0065097d5215bf$export$58b867e287a802c8(bytes) {
    if (!$6d0065097d5215bf$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $6d0065097d5215bf$var$hexes[bytes[i]];
    return hex;
}
function $6d0065097d5215bf$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
const $6d0065097d5215bf$export$bdd553fddd433dcb = async ()=>{};
async function $6d0065097d5215bf$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $6d0065097d5215bf$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $6d0065097d5215bf$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $6d0065097d5215bf$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $6d0065097d5215bf$export$3df70a15530b5e81(data);
    if (!$6d0065097d5215bf$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $6d0065097d5215bf$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$6d0065097d5215bf$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $6d0065097d5215bf$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
// Check if object doens't have custom constructor (like Uint8Array/Array)
const $6d0065097d5215bf$var$isPlainObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
function $6d0065097d5215bf$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$6d0065097d5215bf$var$isPlainObject(opts))) throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $6d0065097d5215bf$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $6d0065097d5215bf$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $6d0065097d5215bf$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6d0065097d5215bf$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $6d0065097d5215bf$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $9hV6m.crypto) && typeof (0, $9hV6m.crypto).getRandomValues === "function") return (0, $9hV6m.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("9hV6m", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $6c31fecb2de06915$export$7effb53edfc7fa2d; });
const $6c31fecb2de06915$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("7i98v", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $54f14d15482dd6fe$export$b3b2de96497acc47; });
$parcel$export(module.exports, "bech32", function () { return $54f14d15482dd6fe$export$27c42482533637da; });
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function $54f14d15482dd6fe$export$dfbcecb440255e4a(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`Wrong integer: ${n}`);
}
function $54f14d15482dd6fe$var$chain(...args) {
    const wrap = (a, b)=>(c)=>a(b(c));
    const encode = Array.from(args).reverse().reduce((acc, i)=>acc ? wrap(acc, i.encode) : i.encode, undefined);
    const decode = args.reduce((acc, i)=>acc ? wrap(acc, i.decode) : i.decode, undefined);
    return {
        encode: encode,
        decode: decode
    };
}
function $54f14d15482dd6fe$var$alphabet(alphabet) {
    return {
        encode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("alphabet.encode input should be an array of numbers");
            return digits.map((i)=>{
                $54f14d15482dd6fe$export$dfbcecb440255e4a(i);
                if (i < 0 || i >= alphabet.length) throw new Error(`Digit index outside alphabet: ${i} (alphabet: ${alphabet.length})`);
                return alphabet[i];
            });
        },
        decode: (input)=>{
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("alphabet.decode input should be array of strings");
            return input.map((letter)=>{
                if (typeof letter !== "string") throw new Error(`alphabet.decode: not string element=${letter}`);
                const index = alphabet.indexOf(letter);
                if (index === -1) throw new Error(`Unknown letter: "${letter}". Allowed: ${alphabet}`);
                return index;
            });
        }
    };
}
function $54f14d15482dd6fe$var$join(separator = "") {
    if (typeof separator !== "string") throw new Error("join separator should be string");
    return {
        encode: (from)=>{
            if (!Array.isArray(from) || from.length && typeof from[0] !== "string") throw new Error("join.encode input should be array of strings");
            for (let i of from)if (typeof i !== "string") throw new Error(`join.encode: non-string input=${i}`);
            return from.join(separator);
        },
        decode: (to)=>{
            if (typeof to !== "string") throw new Error("join.decode input should be string");
            return to.split(separator);
        }
    };
}
function $54f14d15482dd6fe$var$padding(bits, chr = "=") {
    $54f14d15482dd6fe$export$dfbcecb440255e4a(bits);
    if (typeof chr !== "string") throw new Error("padding chr should be string");
    return {
        encode (data) {
            if (!Array.isArray(data) || data.length && typeof data[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of data)if (typeof i !== "string") throw new Error(`padding.encode: non-string input=${i}`);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of input)if (typeof i !== "string") throw new Error(`padding.decode: non-string input=${i}`);
            let end = input.length;
            if (end * bits % 8) throw new Error("Invalid padding: string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                if (!((end - 1) * bits % 8)) throw new Error("Invalid padding: string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
function $54f14d15482dd6fe$var$normalize(fn) {
    if (typeof fn !== "function") throw new Error("normalize fn should be function");
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
function $54f14d15482dd6fe$var$convertRadix(data, from, to) {
    if (from < 2) throw new Error(`convertRadix: wrong from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: wrong to=${to}, base cannot be less than 2`);
    if (!Array.isArray(data)) throw new Error("convertRadix: data should be array");
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data);
    digits.forEach((d)=>{
        $54f14d15482dd6fe$export$dfbcecb440255e4a(d);
        if (d < 0 || d >= from) throw new Error(`Wrong integer: ${d}`);
    });
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < digits.length; i++){
            const digit = digits[i];
            const digitBase = from * carry + digit;
            if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) throw new Error("convertRadix: carry overflow");
            carry = digitBase % to;
            digits[i] = Math.floor(digitBase / to);
            if (!Number.isSafeInteger(digits[i]) || digits[i] * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!digits[i]) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $54f14d15482dd6fe$var$gcd = (a, b)=>!b ? a : $54f14d15482dd6fe$var$gcd(b, a % b);
const $54f14d15482dd6fe$var$radix2carry = (from, to)=>from + (to - $54f14d15482dd6fe$var$gcd(from, to));
function $54f14d15482dd6fe$var$convertRadix2(data, from, to, padding) {
    if (!Array.isArray(data)) throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($54f14d15482dd6fe$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$54f14d15482dd6fe$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0;
    const mask = 2 ** to - 1;
    const res = [];
    for (const n of data){
        $54f14d15482dd6fe$export$dfbcecb440255e4a(n);
        if (n >= 2 ** from) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        carry &= 2 ** pos - 1;
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
function $54f14d15482dd6fe$var$radix(num) {
    $54f14d15482dd6fe$export$dfbcecb440255e4a(num);
    return {
        encode: (bytes)=>{
            if (!(bytes instanceof Uint8Array)) throw new Error("radix.encode input should be Uint8Array");
            return $54f14d15482dd6fe$var$convertRadix(Array.from(bytes), 256, num);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix.decode input should be array of strings");
            return Uint8Array.from($54f14d15482dd6fe$var$convertRadix(digits, num, 256));
        }
    };
}
function $54f14d15482dd6fe$var$radix2(bits, revPadding = false) {
    $54f14d15482dd6fe$export$dfbcecb440255e4a(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($54f14d15482dd6fe$var$radix2carry(8, bits) > 32 || $54f14d15482dd6fe$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: (bytes)=>{
            if (!(bytes instanceof Uint8Array)) throw new Error("radix2.encode input should be Uint8Array");
            return $54f14d15482dd6fe$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix2.decode input should be array of strings");
            return Uint8Array.from($54f14d15482dd6fe$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
function $54f14d15482dd6fe$var$unsafeWrapper(fn) {
    if (typeof fn !== "function") throw new Error("unsafeWrapper fn should be function");
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
function $54f14d15482dd6fe$var$checksum(len, fn) {
    $54f14d15482dd6fe$export$dfbcecb440255e4a(len);
    if (typeof fn !== "function") throw new Error("checksum fn should be function");
    return {
        encode (data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.encode: input should be Uint8Array");
            const checksum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(checksum, data.length);
            return res;
        },
        decode (data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.decode: input should be Uint8Array");
            const payload = data.slice(0, -len);
            const newChecksum = fn(payload).slice(0, len);
            const oldChecksum = data.slice(-len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
const $54f14d15482dd6fe$export$eab97d15b1788b8d = {
    alphabet: $54f14d15482dd6fe$var$alphabet,
    chain: $54f14d15482dd6fe$var$chain,
    checksum: $54f14d15482dd6fe$var$checksum,
    radix: $54f14d15482dd6fe$var$radix,
    radix2: $54f14d15482dd6fe$var$radix2,
    join: $54f14d15482dd6fe$var$join,
    padding: $54f14d15482dd6fe$var$padding
};
const $54f14d15482dd6fe$export$586f61c71cb02fe4 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(4), $54f14d15482dd6fe$var$alphabet("0123456789ABCDEF"), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$4a4d5965e2738b2a = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(5), $54f14d15482dd6fe$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $54f14d15482dd6fe$var$padding(5), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$c57d6760d519c8ac = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(5), $54f14d15482dd6fe$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $54f14d15482dd6fe$var$padding(5), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$5fbcb08925249358 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(5), $54f14d15482dd6fe$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $54f14d15482dd6fe$var$join(""), $54f14d15482dd6fe$var$normalize((s)=>s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
const $54f14d15482dd6fe$export$b3b2de96497acc47 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(6), $54f14d15482dd6fe$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $54f14d15482dd6fe$var$padding(6), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$7d21597c7bc64465 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(6), $54f14d15482dd6fe$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $54f14d15482dd6fe$var$padding(6), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$var$genBase58 = (abc)=>$54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix(58), $54f14d15482dd6fe$var$alphabet(abc), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$export$61f53211c069eefb = $54f14d15482dd6fe$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
const $54f14d15482dd6fe$export$c6a7baed2941aad2 = $54f14d15482dd6fe$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
const $54f14d15482dd6fe$export$cbd4c72942a9201d = $54f14d15482dd6fe$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
const $54f14d15482dd6fe$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $54f14d15482dd6fe$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = "";
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $54f14d15482dd6fe$export$61f53211c069eefb.encode(block).padStart($54f14d15482dd6fe$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $54f14d15482dd6fe$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $54f14d15482dd6fe$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $54f14d15482dd6fe$export$fff625c574161df6 = (sha256)=>$54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$checksum(4, (data)=>sha256(sha256(data))), $54f14d15482dd6fe$export$61f53211c069eefb);
const $54f14d15482dd6fe$var$BECH_ALPHABET = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $54f14d15482dd6fe$var$join(""));
const $54f14d15482dd6fe$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
function $54f14d15482dd6fe$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $54f14d15482dd6fe$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $54f14d15482dd6fe$var$POLYMOD_GENERATORS[i];
    return chk;
}
function $54f14d15482dd6fe$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $54f14d15482dd6fe$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $54f14d15482dd6fe$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $54f14d15482dd6fe$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $54f14d15482dd6fe$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $54f14d15482dd6fe$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $54f14d15482dd6fe$var$BECH_ALPHABET.encode($54f14d15482dd6fe$var$convertRadix2([
        chk % 2 ** 30
    ], 30, 5, false));
}
function $54f14d15482dd6fe$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    const _words = $54f14d15482dd6fe$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $54f14d15482dd6fe$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        if (typeof prefix !== "string") throw new Error(`bech32.encode prefix should be string, not ${typeof prefix}`);
        if (!Array.isArray(words) || words.length && typeof words[0] !== "number") throw new Error(`bech32.encode words should be array of numbers, not ${typeof words}`);
        const actualLength = prefix.length + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        prefix = prefix.toLowerCase();
        return `${prefix}1${$54f14d15482dd6fe$var$BECH_ALPHABET.encode(words)}${$54f14d15482dd6fe$var$bechChecksum(prefix, words, ENCODING_CONST)}`;
    }
    function decode(str, limit = 90) {
        if (typeof str !== "string") throw new Error(`bech32.decode input should be string, not ${typeof str}`);
        if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError(`Wrong string length: ${str.length} (${str}). Expected (8..${limit})`);
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        str = lowered;
        const sepIndex = str.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = str.slice(0, sepIndex);
        const _words = str.slice(sepIndex + 1);
        if (_words.length < 6) throw new Error("Data must be at least 6 characters long");
        const words = $54f14d15482dd6fe$var$BECH_ALPHABET.decode(_words).slice(0, -6);
        const sum = $54f14d15482dd6fe$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!_words.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $54f14d15482dd6fe$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    return {
        encode: encode,
        decode: decode,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $54f14d15482dd6fe$export$27c42482533637da = $54f14d15482dd6fe$var$genBech32("bech32");
const $54f14d15482dd6fe$export$4963f7e473ccf819 = $54f14d15482dd6fe$var$genBech32("bech32m");
const $54f14d15482dd6fe$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
const $54f14d15482dd6fe$export$834dfc94dde4b3d8 = $54f14d15482dd6fe$var$chain($54f14d15482dd6fe$var$radix2(4), $54f14d15482dd6fe$var$alphabet("0123456789abcdef"), $54f14d15482dd6fe$var$join(""), $54f14d15482dd6fe$var$normalize((s)=>{
    if (typeof s !== "string" || s.length % 2) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
const $54f14d15482dd6fe$var$CODERS = {
    utf8: $54f14d15482dd6fe$export$74329b762b589566,
    hex: $54f14d15482dd6fe$export$834dfc94dde4b3d8,
    base16: $54f14d15482dd6fe$export$586f61c71cb02fe4,
    base32: $54f14d15482dd6fe$export$4a4d5965e2738b2a,
    base64: $54f14d15482dd6fe$export$b3b2de96497acc47,
    base64url: $54f14d15482dd6fe$export$7d21597c7bc64465,
    base58: $54f14d15482dd6fe$export$61f53211c069eefb,
    base58xmr: $54f14d15482dd6fe$export$e86cd8e7f8cff4a6
};
const $54f14d15482dd6fe$var$coderTypeError = `Invalid encoding type. Available types: ${Object.keys($54f14d15482dd6fe$var$CODERS).join(", ")}`;
const $54f14d15482dd6fe$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== "string" || !$54f14d15482dd6fe$var$CODERS.hasOwnProperty(type)) throw new TypeError($54f14d15482dd6fe$var$coderTypeError);
    if (!(bytes instanceof Uint8Array)) throw new TypeError("bytesToString() expects Uint8Array");
    return $54f14d15482dd6fe$var$CODERS[type].encode(bytes);
};
const $54f14d15482dd6fe$export$42d51816ce590c93 = $54f14d15482dd6fe$export$7c746b75f47c9c7d;
const $54f14d15482dd6fe$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$54f14d15482dd6fe$var$CODERS.hasOwnProperty(type)) throw new TypeError($54f14d15482dd6fe$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $54f14d15482dd6fe$var$CODERS[type].decode(str);
};
const $54f14d15482dd6fe$export$b3317979f9250576 = $54f14d15482dd6fe$export$c8dd6bc66a63753c;

});

parcelRegister("lPiFO", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $fe3cd88c751d9c9f$export$529e6123e9353a90; });
$parcel$export(module.exports, "schnorr", function () { return $fe3cd88c751d9c9f$export$1f2401df071be9f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $e4M0B = parcelRequire("e4M0B");

var $enX28 = parcelRequire("enX28");

var $bY3t9 = parcelRequire("bY3t9");

var $hSGv7 = parcelRequire("hSGv7");

var $fXSBq = parcelRequire("fXSBq");

var $d70Fk = parcelRequire("d70Fk");

var $9jCG1 = parcelRequire("9jCG1");
const $fe3cd88c751d9c9f$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $fe3cd88c751d9c9f$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $fe3cd88c751d9c9f$var$_1n = BigInt(1);
const $fe3cd88c751d9c9f$var$_2n = BigInt(2);
const $fe3cd88c751d9c9f$var$divNearest = (a, b)=>(a + b / $fe3cd88c751d9c9f$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $fe3cd88c751d9c9f$var$sqrtMod(y) {
    const P = $fe3cd88c751d9c9f$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $bY3t9.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $bY3t9.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $bY3t9.pow2)(b9, $fe3cd88c751d9c9f$var$_2n, P) * b2 % P;
    const b22 = (0, $bY3t9.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $bY3t9.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $bY3t9.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $bY3t9.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $bY3t9.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $bY3t9.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $bY3t9.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $bY3t9.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $bY3t9.pow2)(t2, $fe3cd88c751d9c9f$var$_2n, P);
    if (!$fe3cd88c751d9c9f$var$Fp.eql($fe3cd88c751d9c9f$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $fe3cd88c751d9c9f$var$Fp = (0, $bY3t9.Field)($fe3cd88c751d9c9f$var$secp256k1P, undefined, undefined, {
    sqrt: $fe3cd88c751d9c9f$var$sqrtMod
});
const $fe3cd88c751d9c9f$export$529e6123e9353a90 = (0, $9jCG1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $fe3cd88c751d9c9f$var$Fp,
    n: $fe3cd88c751d9c9f$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $fe3cd88c751d9c9f$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$fe3cd88c751d9c9f$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $fe3cd88c751d9c9f$var$divNearest(b2 * k, n);
            const c2 = $fe3cd88c751d9c9f$var$divNearest(-b1 * k, n);
            let k1 = (0, $bY3t9.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $bY3t9.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $e4M0B.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $fe3cd88c751d9c9f$var$_0n = BigInt(0);
const $fe3cd88c751d9c9f$var$fe = (x)=>typeof x === "bigint" && $fe3cd88c751d9c9f$var$_0n < x && x < $fe3cd88c751d9c9f$var$secp256k1P;
const $fe3cd88c751d9c9f$var$ge = (x)=>typeof x === "bigint" && $fe3cd88c751d9c9f$var$_0n < x && x < $fe3cd88c751d9c9f$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $fe3cd88c751d9c9f$var$TAGGED_HASH_PREFIXES = {};
function $fe3cd88c751d9c9f$var$taggedHash(tag, ...messages) {
    let tagP = $fe3cd88c751d9c9f$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $e4M0B.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $fXSBq.concatBytes)(tagH, tagH);
        $fe3cd88c751d9c9f$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $e4M0B.sha256)((0, $fXSBq.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $fe3cd88c751d9c9f$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $fe3cd88c751d9c9f$var$numTo32b = (n)=>(0, $fXSBq.numberToBytesBE)(n, 32);
const $fe3cd88c751d9c9f$var$modP = (x)=>(0, $bY3t9.mod)(x, $fe3cd88c751d9c9f$var$secp256k1P);
const $fe3cd88c751d9c9f$var$modN = (x)=>(0, $bY3t9.mod)(x, $fe3cd88c751d9c9f$var$secp256k1N);
const $fe3cd88c751d9c9f$var$Point = $fe3cd88c751d9c9f$export$529e6123e9353a90.ProjectivePoint;
const $fe3cd88c751d9c9f$var$GmulAdd = (Q, a, b)=>$fe3cd88c751d9c9f$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $fe3cd88c751d9c9f$var$schnorrGetExtPubKey(priv) {
    let d_ = $fe3cd88c751d9c9f$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $fe3cd88c751d9c9f$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $fe3cd88c751d9c9f$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $fe3cd88c751d9c9f$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $fe3cd88c751d9c9f$var$lift_x(x) {
    if (!$fe3cd88c751d9c9f$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $fe3cd88c751d9c9f$var$modP(x * x);
    const c = $fe3cd88c751d9c9f$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $fe3cd88c751d9c9f$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $fe3cd88c751d9c9f$var$_2n !== $fe3cd88c751d9c9f$var$_0n) y = $fe3cd88c751d9c9f$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $fe3cd88c751d9c9f$var$Point(x, y, $fe3cd88c751d9c9f$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $fe3cd88c751d9c9f$var$challenge(...args) {
    return $fe3cd88c751d9c9f$var$modN((0, $fXSBq.bytesToNumberBE)($fe3cd88c751d9c9f$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $fe3cd88c751d9c9f$var$schnorrGetPublicKey(privateKey) {
    return $fe3cd88c751d9c9f$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $fe3cd88c751d9c9f$var$schnorrSign(message, privateKey, auxRand = (0, $enX28.randomBytes)(32)) {
    const m = (0, $fXSBq.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $fe3cd88c751d9c9f$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $fXSBq.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $fe3cd88c751d9c9f$var$numTo32b(d ^ (0, $fXSBq.bytesToNumberBE)($fe3cd88c751d9c9f$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $fe3cd88c751d9c9f$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $fe3cd88c751d9c9f$var$modN((0, $fXSBq.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $fe3cd88c751d9c9f$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $fe3cd88c751d9c9f$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $fe3cd88c751d9c9f$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($fe3cd88c751d9c9f$var$numTo32b($fe3cd88c751d9c9f$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$fe3cd88c751d9c9f$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $fe3cd88c751d9c9f$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $fXSBq.ensureBytes)("signature", signature, 64);
    const m = (0, $fXSBq.ensureBytes)("message", message);
    const pub = (0, $fXSBq.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $fe3cd88c751d9c9f$var$lift_x((0, $fXSBq.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $fXSBq.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$fe3cd88c751d9c9f$var$fe(r)) return false;
        const s = (0, $fXSBq.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$fe3cd88c751d9c9f$var$ge(s)) return false;
        const e = $fe3cd88c751d9c9f$var$challenge($fe3cd88c751d9c9f$var$numTo32b(r), $fe3cd88c751d9c9f$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $fe3cd88c751d9c9f$var$GmulAdd(P, s, $fe3cd88c751d9c9f$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $fe3cd88c751d9c9f$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $fe3cd88c751d9c9f$var$schnorrGetPublicKey,
        sign: $fe3cd88c751d9c9f$var$schnorrSign,
        verify: $fe3cd88c751d9c9f$var$schnorrVerify,
        utils: {
            randomPrivateKey: $fe3cd88c751d9c9f$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $fe3cd88c751d9c9f$var$lift_x,
            pointToBytes: $fe3cd88c751d9c9f$var$pointToBytes,
            numberToBytesBE: $fXSBq.numberToBytesBE,
            bytesToNumberBE: $fXSBq.bytesToNumberBE,
            taggedHash: $fe3cd88c751d9c9f$var$taggedHash,
            mod: $bY3t9.mod
        }
    }))();
const $fe3cd88c751d9c9f$var$isoMap = /* @__PURE__ */ (()=>(0, $d70Fk.isogenyMap)($fe3cd88c751d9c9f$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $fe3cd88c751d9c9f$var$mapSWU = /* @__PURE__ */ (()=>(0, $hSGv7.mapToCurveSimpleSWU)($fe3cd88c751d9c9f$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $fe3cd88c751d9c9f$var$Fp.create(BigInt("-11"))
    }))();
const $fe3cd88c751d9c9f$var$htf = /* @__PURE__ */ (()=>(0, $d70Fk.createHasher)($fe3cd88c751d9c9f$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $fe3cd88c751d9c9f$var$mapSWU($fe3cd88c751d9c9f$var$Fp.create(scalars[0]));
        return $fe3cd88c751d9c9f$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $fe3cd88c751d9c9f$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $e4M0B.sha256)
    }))();
const $fe3cd88c751d9c9f$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$fe3cd88c751d9c9f$var$htf.hashToCurve)();
const $fe3cd88c751d9c9f$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$fe3cd88c751d9c9f$var$htf.encodeToCurve)();

});
parcelRegister("e4M0B", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $a3f6adf0136b3cb2$export$bced8d2aada2d1c9; });

var $kROaS = parcelRequire("kROaS");

var $enX28 = parcelRequire("enX28");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $a3f6adf0136b3cb2$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $a3f6adf0136b3cb2$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $a3f6adf0136b3cb2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $a3f6adf0136b3cb2$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $a3f6adf0136b3cb2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $a3f6adf0136b3cb2$var$SHA256 extends (0, $kROaS.SHA2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $a3f6adf0136b3cb2$var$IV[0] | 0;
        this.B = $a3f6adf0136b3cb2$var$IV[1] | 0;
        this.C = $a3f6adf0136b3cb2$var$IV[2] | 0;
        this.D = $a3f6adf0136b3cb2$var$IV[3] | 0;
        this.E = $a3f6adf0136b3cb2$var$IV[4] | 0;
        this.F = $a3f6adf0136b3cb2$var$IV[5] | 0;
        this.G = $a3f6adf0136b3cb2$var$IV[6] | 0;
        this.H = $a3f6adf0136b3cb2$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$a3f6adf0136b3cb2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $a3f6adf0136b3cb2$var$SHA256_W[i - 15];
            const W2 = $a3f6adf0136b3cb2$var$SHA256_W[i - 2];
            const s0 = (0, $enX28.rotr)(W15, 7) ^ (0, $enX28.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $enX28.rotr)(W2, 17) ^ (0, $enX28.rotr)(W2, 19) ^ W2 >>> 10;
            $a3f6adf0136b3cb2$var$SHA256_W[i] = s1 + $a3f6adf0136b3cb2$var$SHA256_W[i - 7] + s0 + $a3f6adf0136b3cb2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $enX28.rotr)(E, 6) ^ (0, $enX28.rotr)(E, 11) ^ (0, $enX28.rotr)(E, 25);
            const T1 = H + sigma1 + $a3f6adf0136b3cb2$var$Chi(E, F, G) + $a3f6adf0136b3cb2$var$SHA256_K[i] + $a3f6adf0136b3cb2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $enX28.rotr)(A, 2) ^ (0, $enX28.rotr)(A, 13) ^ (0, $enX28.rotr)(A, 22);
            const T2 = sigma0 + $a3f6adf0136b3cb2$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $a3f6adf0136b3cb2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $a3f6adf0136b3cb2$var$SHA224 extends $a3f6adf0136b3cb2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $a3f6adf0136b3cb2$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $enX28.wrapConstructor)(()=>new $a3f6adf0136b3cb2$var$SHA256());
const $a3f6adf0136b3cb2$export$97b70509d4e397ea = /* @__PURE__ */ (0, $enX28.wrapConstructor)(()=>new $a3f6adf0136b3cb2$var$SHA224());

});
parcelRegister("kROaS", function(module, exports) {

$parcel$export(module.exports, "SHA2", function () { return $f30fad763fa14c67$export$ebbe38f24b9a0856; });

var $3r5uY = parcelRequire("3r5uY");

var $enX28 = parcelRequire("enX28");
// Polyfill for Safari 14
function $f30fad763fa14c67$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $f30fad763fa14c67$export$ebbe38f24b9a0856 extends (0, $enX28.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $enX28.createView)(this.buffer);
    }
    update(data) {
        (0, $3r5uY.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $enX28.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $enX28.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $3r5uY.exists)(this);
        (0, $3r5uY.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $f30fad763fa14c67$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $enX28.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});
parcelRegister("3r5uY", function(module, exports) {

$parcel$export(module.exports, "bytes", function () { return $2808289d360d4aed$export$b3317979f9250576; });
$parcel$export(module.exports, "hash", function () { return $2808289d360d4aed$export$d6af199866bfb566; });
$parcel$export(module.exports, "exists", function () { return $2808289d360d4aed$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $2808289d360d4aed$export$c789db2c85949867; });
function $2808289d360d4aed$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $2808289d360d4aed$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
function $2808289d360d4aed$export$b3317979f9250576(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $2808289d360d4aed$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $2808289d360d4aed$export$98e628dec113755e(hash.outputLen);
    $2808289d360d4aed$export$98e628dec113755e(hash.blockLen);
}
function $2808289d360d4aed$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $2808289d360d4aed$export$c789db2c85949867(out, instance) {
    $2808289d360d4aed$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $2808289d360d4aed$var$assert = {
    number: $2808289d360d4aed$export$98e628dec113755e,
    bool: $2808289d360d4aed$export$87b259aa03e3d267,
    bytes: $2808289d360d4aed$export$b3317979f9250576,
    hash: $2808289d360d4aed$export$d6af199866bfb566,
    exists: $2808289d360d4aed$export$f7e9f41ea797a17,
    output: $2808289d360d4aed$export$c789db2c85949867
};
var $2808289d360d4aed$export$2e2bcd8739ae039 = $2808289d360d4aed$var$assert;

});

parcelRegister("enX28", function(module, exports) {

$parcel$export(module.exports, "createView", function () { return $a7910176f6626945$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $a7910176f6626945$export$466993d7d0d272aa; });
$parcel$export(module.exports, "toBytes", function () { return $a7910176f6626945$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $a7910176f6626945$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $a7910176f6626945$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $a7910176f6626945$export$f081816339df1972; });
$parcel$export(module.exports, "randomBytes", function () { return $a7910176f6626945$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.

var $KZzgK = parcelRequire("KZzgK");
const $a7910176f6626945$var$u8a = (a)=>a instanceof Uint8Array;
const $a7910176f6626945$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $a7910176f6626945$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $a7910176f6626945$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $a7910176f6626945$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $a7910176f6626945$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$a7910176f6626945$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
const $a7910176f6626945$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $a7910176f6626945$export$58b867e287a802c8(bytes) {
    if (!$a7910176f6626945$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a7910176f6626945$var$hexes[bytes[i]];
    return hex;
}
function $a7910176f6626945$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
const $a7910176f6626945$export$bdd553fddd433dcb = async ()=>{};
async function $a7910176f6626945$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $a7910176f6626945$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $a7910176f6626945$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $a7910176f6626945$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $a7910176f6626945$export$3df70a15530b5e81(data);
    if (!$a7910176f6626945$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $a7910176f6626945$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a7910176f6626945$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
class $a7910176f6626945$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $a7910176f6626945$var$toStr = {}.toString;
function $a7910176f6626945$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $a7910176f6626945$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $a7910176f6626945$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($a7910176f6626945$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $a7910176f6626945$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a7910176f6626945$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a7910176f6626945$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a7910176f6626945$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a7910176f6626945$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $KZzgK.crypto) && typeof (0, $KZzgK.crypto).getRandomValues === "function") return (0, $KZzgK.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("KZzgK", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $08d40e160ceb103e$export$7effb53edfc7fa2d; });
const $08d40e160ceb103e$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("bY3t9", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $8b67fd3be4c8950a$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow2", function () { return $8b67fd3be4c8950a$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $8b67fd3be4c8950a$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "validateField", function () { return $8b67fd3be4c8950a$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $8b67fd3be4c8950a$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $8b67fd3be4c8950a$export$a455218a85c89869; });
$parcel$export(module.exports, "getMinHashLength", function () { return $8b67fd3be4c8950a$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $8b67fd3be4c8950a$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $fXSBq = parcelRequire("fXSBq");
// prettier-ignore
const $8b67fd3be4c8950a$var$_0n = BigInt(0), $8b67fd3be4c8950a$var$_1n = BigInt(1), $8b67fd3be4c8950a$var$_2n = BigInt(2), $8b67fd3be4c8950a$var$_3n = BigInt(3);
// prettier-ignore
const $8b67fd3be4c8950a$var$_4n = BigInt(4), $8b67fd3be4c8950a$var$_5n = BigInt(5), $8b67fd3be4c8950a$var$_8n = BigInt(8);
// prettier-ignore
const $8b67fd3be4c8950a$var$_9n = BigInt(9), $8b67fd3be4c8950a$var$_16n = BigInt(16);
function $8b67fd3be4c8950a$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $8b67fd3be4c8950a$var$_0n ? result : b + result;
}
function $8b67fd3be4c8950a$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $8b67fd3be4c8950a$var$_0n || power < $8b67fd3be4c8950a$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $8b67fd3be4c8950a$var$_1n) return $8b67fd3be4c8950a$var$_0n;
    let res = $8b67fd3be4c8950a$var$_1n;
    while(power > $8b67fd3be4c8950a$var$_0n){
        if (power & $8b67fd3be4c8950a$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $8b67fd3be4c8950a$var$_1n;
    }
    return res;
}
function $8b67fd3be4c8950a$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $8b67fd3be4c8950a$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $8b67fd3be4c8950a$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $8b67fd3be4c8950a$var$_0n || modulo <= $8b67fd3be4c8950a$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $8b67fd3be4c8950a$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $8b67fd3be4c8950a$var$_0n, y = $8b67fd3be4c8950a$var$_1n, u = $8b67fd3be4c8950a$var$_1n, v = $8b67fd3be4c8950a$var$_0n;
    while(a !== $8b67fd3be4c8950a$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $8b67fd3be4c8950a$var$_1n) throw new Error("invert: does not exist");
    return $8b67fd3be4c8950a$export$842a2cf37af977e1(x, modulo);
}
function $8b67fd3be4c8950a$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $8b67fd3be4c8950a$var$_1n, S = 0; Q % $8b67fd3be4c8950a$var$_2n === $8b67fd3be4c8950a$var$_0n; Q /= $8b67fd3be4c8950a$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $8b67fd3be4c8950a$var$_2n; Z < P && $8b67fd3be4c8950a$export$9c297f60e22e3389(Z, legendreC, P) !== P - $8b67fd3be4c8950a$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $8b67fd3be4c8950a$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $8b67fd3be4c8950a$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $8b67fd3be4c8950a$var$_4n === $8b67fd3be4c8950a$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $8b67fd3be4c8950a$var$_8n === $8b67fd3be4c8950a$var$_5n) {
        const c1 = (P - $8b67fd3be4c8950a$var$_5n) / $8b67fd3be4c8950a$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $8b67fd3be4c8950a$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $8b67fd3be4c8950a$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $8b67fd3be4c8950a$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $8b67fd3be4c8950a$export$69f29ab1f3e9a234(P);
}
const $8b67fd3be4c8950a$export$7806f13ad5078b2f = (num, modulo)=>($8b67fd3be4c8950a$export$842a2cf37af977e1(num, modulo) & $8b67fd3be4c8950a$var$_1n) === $8b67fd3be4c8950a$var$_1n;
// prettier-ignore
const $8b67fd3be4c8950a$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $8b67fd3be4c8950a$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $8b67fd3be4c8950a$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $fXSBq.validateObject)(field, opts);
}
function $8b67fd3be4c8950a$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $8b67fd3be4c8950a$var$_0n) throw new Error("Expected power > 0");
    if (power === $8b67fd3be4c8950a$var$_0n) return f.ONE;
    if (power === $8b67fd3be4c8950a$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $8b67fd3be4c8950a$var$_0n){
        if (power & $8b67fd3be4c8950a$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $8b67fd3be4c8950a$var$_1n;
    }
    return p;
}
function $8b67fd3be4c8950a$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $8b67fd3be4c8950a$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $8b67fd3be4c8950a$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $8b67fd3be4c8950a$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $8b67fd3be4c8950a$var$_1n) / $8b67fd3be4c8950a$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $8b67fd3be4c8950a$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $8b67fd3be4c8950a$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $8b67fd3be4c8950a$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $8b67fd3be4c8950a$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $8b67fd3be4c8950a$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $fXSBq.bitMask)(BITS),
        ZERO: $8b67fd3be4c8950a$var$_0n,
        ONE: $8b67fd3be4c8950a$var$_1n,
        create: (num)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $8b67fd3be4c8950a$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $8b67fd3be4c8950a$var$_0n,
        isOdd: (num)=>(num & $8b67fd3be4c8950a$var$_1n) === $8b67fd3be4c8950a$var$_1n,
        neg: (num)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$8b67fd3be4c8950a$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$8b67fd3be4c8950a$export$842a2cf37af977e1(lhs * $8b67fd3be4c8950a$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$8b67fd3be4c8950a$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$8b67fd3be4c8950a$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $fXSBq.numberToBytesLE)(num, BYTES) : (0, $fXSBq.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $fXSBq.bytesToNumberLE)(bytes) : (0, $fXSBq.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $8b67fd3be4c8950a$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $8b67fd3be4c8950a$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $8b67fd3be4c8950a$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $fXSBq.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $8b67fd3be4c8950a$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $fXSBq.bytesToNumberLE)(hash) : (0, $fXSBq.bytesToNumberBE)(hash);
    return $8b67fd3be4c8950a$export$842a2cf37af977e1(num, groupOrder - $8b67fd3be4c8950a$var$_1n) + $8b67fd3be4c8950a$var$_1n;
}
function $8b67fd3be4c8950a$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $8b67fd3be4c8950a$export$d058763b563056af(fieldOrder) {
    const length = $8b67fd3be4c8950a$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $8b67fd3be4c8950a$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $8b67fd3be4c8950a$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $8b67fd3be4c8950a$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $fXSBq.bytesToNumberBE)(key) : (0, $fXSBq.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $8b67fd3be4c8950a$export$842a2cf37af977e1(num, fieldOrder - $8b67fd3be4c8950a$var$_1n) + $8b67fd3be4c8950a$var$_1n;
    return isLE ? (0, $fXSBq.numberToBytesLE)(reduced, fieldLen) : (0, $fXSBq.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("fXSBq", function(module, exports) {

$parcel$export(module.exports, "bytesToHex", function () { return $b9f6b8a8ad1eccc7$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $b9f6b8a8ad1eccc7$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $b9f6b8a8ad1eccc7$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $b9f6b8a8ad1eccc7$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $b9f6b8a8ad1eccc7$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $b9f6b8a8ad1eccc7$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $b9f6b8a8ad1eccc7$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $b9f6b8a8ad1eccc7$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $b9f6b8a8ad1eccc7$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $b9f6b8a8ad1eccc7$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $b9f6b8a8ad1eccc7$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $b9f6b8a8ad1eccc7$export$3df70a15530b5e81; });
$parcel$export(module.exports, "bitLen", function () { return $b9f6b8a8ad1eccc7$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $b9f6b8a8ad1eccc7$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $b9f6b8a8ad1eccc7$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $b9f6b8a8ad1eccc7$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $b9f6b8a8ad1eccc7$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $b9f6b8a8ad1eccc7$export$381bae2d0f08004f; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $b9f6b8a8ad1eccc7$var$_0n = BigInt(0);
const $b9f6b8a8ad1eccc7$var$_1n = BigInt(1);
const $b9f6b8a8ad1eccc7$var$_2n = BigInt(2);
const $b9f6b8a8ad1eccc7$var$u8a = (a)=>a instanceof Uint8Array;
const $b9f6b8a8ad1eccc7$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $b9f6b8a8ad1eccc7$export$58b867e287a802c8(bytes) {
    if (!$b9f6b8a8ad1eccc7$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $b9f6b8a8ad1eccc7$var$hexes[bytes[i]];
    return hex;
}
function $b9f6b8a8ad1eccc7$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $b9f6b8a8ad1eccc7$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
function $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
function $b9f6b8a8ad1eccc7$export$d609354794974f8(bytes) {
    return $b9f6b8a8ad1eccc7$export$d57f2bacc26b4249($b9f6b8a8ad1eccc7$export$58b867e287a802c8(bytes));
}
function $b9f6b8a8ad1eccc7$export$d67b1d03392107e7(bytes) {
    if (!$b9f6b8a8ad1eccc7$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $b9f6b8a8ad1eccc7$export$d57f2bacc26b4249($b9f6b8a8ad1eccc7$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $b9f6b8a8ad1eccc7$export$1459dafd057611cb(n, len) {
    return $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $b9f6b8a8ad1eccc7$export$ba2172e58d139f6d(n, len) {
    return $b9f6b8a8ad1eccc7$export$1459dafd057611cb(n, len).reverse();
}
function $b9f6b8a8ad1eccc7$export$80ee8c1914de6dde(n) {
    return $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4($b9f6b8a8ad1eccc7$export$4ed2545b622827c1(n));
}
function $b9f6b8a8ad1eccc7$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $b9f6b8a8ad1eccc7$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($b9f6b8a8ad1eccc7$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $b9f6b8a8ad1eccc7$export$287dd7971339c972(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$b9f6b8a8ad1eccc7$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
function $b9f6b8a8ad1eccc7$export$2aa59cef064b0333(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
function $b9f6b8a8ad1eccc7$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $b9f6b8a8ad1eccc7$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $b9f6b8a8ad1eccc7$var$_0n; n >>= $b9f6b8a8ad1eccc7$var$_1n, len += 1);
    return len;
}
function $b9f6b8a8ad1eccc7$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $b9f6b8a8ad1eccc7$var$_1n;
}
const $b9f6b8a8ad1eccc7$export$967bb2b9787441cb = (n, pos, value)=>{
    return n | (value ? $b9f6b8a8ad1eccc7$var$_1n : $b9f6b8a8ad1eccc7$var$_0n) << BigInt(pos);
};
const $b9f6b8a8ad1eccc7$export$803efa2fa1c7279 = (n)=>($b9f6b8a8ad1eccc7$var$_2n << BigInt(n - 1)) - $b9f6b8a8ad1eccc7$var$_1n;
// DRBG
const $b9f6b8a8ad1eccc7$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $b9f6b8a8ad1eccc7$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $b9f6b8a8ad1eccc7$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $b9f6b8a8ad1eccc7$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $b9f6b8a8ad1eccc7$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $b9f6b8a8ad1eccc7$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($b9f6b8a8ad1eccc7$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($b9f6b8a8ad1eccc7$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $b9f6b8a8ad1eccc7$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $b9f6b8a8ad1eccc7$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $b9f6b8a8ad1eccc7$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $b9f6b8a8ad1eccc7$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("hSGv7", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $d048729b0f3a361e$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $d048729b0f3a361e$export$cc7fea9756a17416; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $bY3t9 = parcelRequire("bY3t9");

var $fXSBq = parcelRequire("fXSBq");

var $d14TS = parcelRequire("d14TS");
function $d048729b0f3a361e$var$validatePointOpts(curve) {
    const opts = (0, $d14TS.validateBasic)(curve);
    $fXSBq.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $d048729b0f3a361e$var$b2n, hexToBytes: $d048729b0f3a361e$var$h2b } = $fXSBq;
const $d048729b0f3a361e$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $d048729b0f3a361e$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $d048729b0f3a361e$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $d048729b0f3a361e$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $d048729b0f3a361e$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $d048729b0f3a361e$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $d048729b0f3a361e$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $d048729b0f3a361e$var$_0n = BigInt(0), $d048729b0f3a361e$var$_1n = BigInt(1), $d048729b0f3a361e$var$_2n = BigInt(2), $d048729b0f3a361e$var$_3n = BigInt(3), $d048729b0f3a361e$var$_4n = BigInt(4);
function $d048729b0f3a361e$export$fa783af82e4fe0fc(opts) {
    const CURVE = $d048729b0f3a361e$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $fXSBq.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $d048729b0f3a361e$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $fXSBq.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $fXSBq.bytesToNumberBE((0, $fXSBq.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $bY3t9.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $fXSBq.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $d048729b0f3a361e$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $d048729b0f3a361e$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $d048729b0f3a361e$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $d048729b0f3a361e$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $d048729b0f3a361e$var$_0n || k2 > $d048729b0f3a361e$var$_0n){
                if (k1 & $d048729b0f3a361e$var$_1n) k1p = k1p.add(d);
                if (k2 & $d048729b0f3a361e$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $d048729b0f3a361e$var$_1n;
                k2 >>= $d048729b0f3a361e$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $d048729b0f3a361e$var$_0n || a === $d048729b0f3a361e$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $d048729b0f3a361e$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $d048729b0f3a361e$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $fXSBq.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $d14TS.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $d048729b0f3a361e$var$validateOpts(curve) {
    const opts = (0, $d14TS.validateBasic)(curve);
    $fXSBq.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $d048729b0f3a361e$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $d048729b0f3a361e$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $d048729b0f3a361e$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $bY3t9.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $bY3t9.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $d048729b0f3a361e$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $fXSBq.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $fXSBq.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $d048729b0f3a361e$var$_1n) === $d048729b0f3a361e$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$fXSBq.bytesToHex($fXSBq.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $d048729b0f3a361e$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$fXSBq.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $fXSBq.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $d048729b0f3a361e$export$56ac33195d7076db.toSig((0, $fXSBq.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $fXSBq.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $fXSBq.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $d048729b0f3a361e$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $fXSBq.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $bY3t9.getMinHashLength(CURVE.n);
            return $bY3t9.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $fXSBq.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $fXSBq.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($d048729b0f3a361e$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $fXSBq.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $fXSBq.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $fXSBq.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $fXSBq.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $fXSBq.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $d048729b0f3a361e$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $d048729b0f3a361e$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $d048729b0f3a361e$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $fXSBq.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $fXSBq.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $fXSBq.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $d048729b0f3a361e$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $d048729b0f3a361e$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $d048729b0f3a361e$var$_0n;
    for(let o = q - $d048729b0f3a361e$var$_1n; o % $d048729b0f3a361e$var$_2n === $d048729b0f3a361e$var$_0n; o /= $d048729b0f3a361e$var$_2n)l += $d048729b0f3a361e$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $d048729b0f3a361e$var$_2n << c1 - $d048729b0f3a361e$var$_1n - $d048729b0f3a361e$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $d048729b0f3a361e$var$_2n;
    const c2 = (q - $d048729b0f3a361e$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $d048729b0f3a361e$var$_1n) / $d048729b0f3a361e$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $d048729b0f3a361e$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $d048729b0f3a361e$var$_1n) / $d048729b0f3a361e$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $d048729b0f3a361e$var$_1n; i--){
            let tv5 = i - $d048729b0f3a361e$var$_2n; // 18.    tv5 = i - 2
            tv5 = $d048729b0f3a361e$var$_2n << tv5 - $d048729b0f3a361e$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $d048729b0f3a361e$var$_4n === $d048729b0f3a361e$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $d048729b0f3a361e$var$_3n) / $d048729b0f3a361e$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $d048729b0f3a361e$export$cc7fea9756a17416(Fp, opts) {
    $bY3t9.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $d048729b0f3a361e$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("d14TS", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $bY3t9 = parcelRequire("bY3t9");

var $fXSBq = parcelRequire("fXSBq");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $bY3t9.validateField)(curve.Fp);
    (0, $fXSBq.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $bY3t9.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});


parcelRegister("d70Fk", function(module, exports) {

$parcel$export(module.exports, "isogenyMap", function () { return $98bc71fbece483b9$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $98bc71fbece483b9$export$14b114effbc08b6b; });

var $bY3t9 = parcelRequire("bY3t9");

var $fXSBq = parcelRequire("fXSBq");
function $98bc71fbece483b9$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $fXSBq.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $98bc71fbece483b9$var$os2ip = (0, $fXSBq.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $98bc71fbece483b9$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $98bc71fbece483b9$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $98bc71fbece483b9$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $98bc71fbece483b9$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $98bc71fbece483b9$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    $98bc71fbece483b9$var$isBytes(msg);
    $98bc71fbece483b9$var$isBytes(DST);
    $98bc71fbece483b9$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $fXSBq.concatBytes)((0, $fXSBq.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $fXSBq.concatBytes)(DST, $98bc71fbece483b9$var$i2osp(DST.length, 1));
    const Z_pad = $98bc71fbece483b9$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $98bc71fbece483b9$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $fXSBq.concatBytes)(Z_pad, msg, l_i_b_str, $98bc71fbece483b9$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $fXSBq.concatBytes)(b_0, $98bc71fbece483b9$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $98bc71fbece483b9$var$strxor(b_0, b[i - 1]),
            $98bc71fbece483b9$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $fXSBq.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $fXSBq.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $98bc71fbece483b9$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    $98bc71fbece483b9$var$isBytes(msg);
    $98bc71fbece483b9$var$isBytes(DST);
    $98bc71fbece483b9$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $fXSBq.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($98bc71fbece483b9$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($98bc71fbece483b9$var$i2osp(DST.length, 1)).digest();
}
function $98bc71fbece483b9$export$97cdd5ee18de8172(msg, count, options) {
    (0, $fXSBq.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $98bc71fbece483b9$var$isBytes(msg);
    $98bc71fbece483b9$var$isNum(count);
    const DST = $98bc71fbece483b9$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $98bc71fbece483b9$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $98bc71fbece483b9$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $bY3t9.mod)($98bc71fbece483b9$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $98bc71fbece483b9$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $98bc71fbece483b9$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $98bc71fbece483b9$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $98bc71fbece483b9$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});

parcelRegister("9jCG1", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $6c83e3d022918030$export$3f2f6721dd02558a; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $lVwA3 = parcelRequire("lVwA3");

var $enX28 = parcelRequire("enX28");

var $hSGv7 = parcelRequire("hSGv7");
function $6c83e3d022918030$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $lVwA3.hmac)(hash, key, (0, $enX28.concatBytes)(...msgs)),
        randomBytes: $enX28.randomBytes
    };
}
function $6c83e3d022918030$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $hSGv7.weierstrass)({
            ...curveDef,
            ...$6c83e3d022918030$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}

});
parcelRegister("lVwA3", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $ff6831a1f76c6081$export$355af40f8ab02f34; });

var $3r5uY = parcelRequire("3r5uY");

var $enX28 = parcelRequire("enX28");
class $ff6831a1f76c6081$export$7b9cf41ebec74f45 extends (0, $enX28.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $3r5uY.hash)(hash);
        const key = (0, $enX28.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $3r5uY.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $3r5uY.exists)(this);
        (0, $3r5uY.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $ff6831a1f76c6081$export$355af40f8ab02f34 = (hash, key, message)=>new $ff6831a1f76c6081$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$ff6831a1f76c6081$export$355af40f8ab02f34.create = (hash, key)=>new $ff6831a1f76c6081$export$7b9cf41ebec74f45(hash, key);

});




var $dc6El = parcelRequire("dc6El");
// nip98.ts

var $kHnZL = parcelRequire("kHnZL");

var $9mdbq = parcelRequire("9mdbq");

var $7i98v = parcelRequire("7i98v");

var $lPiFO = parcelRequire("lPiFO");
// kinds.ts
var $e7b737bc38c0792a$var$HTTPAuth = 27235;
// core.ts
var $e7b737bc38c0792a$var$verifiedSymbol = Symbol("verified");
var $e7b737bc38c0792a$var$isRecord = (obj)=>obj instanceof Object;
function $e7b737bc38c0792a$var$validateEvent(event) {
    if (!$e7b737bc38c0792a$var$isRecord(event)) return false;
    if (typeof event.kind !== "number") return false;
    if (typeof event.content !== "string") return false;
    if (typeof event.created_at !== "number") return false;
    if (typeof event.pubkey !== "string") return false;
    if (!event.pubkey.match(/^[a-f0-9]{64}$/)) return false;
    if (!Array.isArray(event.tags)) return false;
    for(let i2 = 0; i2 < event.tags.length; i2++){
        let tag = event.tags[i2];
        if (!Array.isArray(tag)) return false;
        for(let j = 0; j < tag.length; j++){
            if (typeof tag[j] === "object") return false;
        }
    }
    return true;
}
// utils.ts
var $e7b737bc38c0792a$var$utf8Decoder = new TextDecoder("utf-8");
var $e7b737bc38c0792a$var$utf8Encoder = new TextEncoder();
// pure.ts
var $e7b737bc38c0792a$var$JS = class {
    generateSecretKey() {
        return (0, $lPiFO.schnorr).utils.randomPrivateKey();
    }
    getPublicKey(secretKey) {
        return (0, $9mdbq.bytesToHex)((0, $lPiFO.schnorr).getPublicKey(secretKey));
    }
    finalizeEvent(t, secretKey) {
        const event = t;
        event.pubkey = (0, $9mdbq.bytesToHex)((0, $lPiFO.schnorr).getPublicKey(secretKey));
        event.id = $e7b737bc38c0792a$var$getEventHash(event);
        event.sig = (0, $9mdbq.bytesToHex)((0, $lPiFO.schnorr).sign($e7b737bc38c0792a$var$getEventHash(event), secretKey));
        event[$e7b737bc38c0792a$var$verifiedSymbol] = true;
        return event;
    }
    verifyEvent(event) {
        if (typeof event[$e7b737bc38c0792a$var$verifiedSymbol] === "boolean") return event[$e7b737bc38c0792a$var$verifiedSymbol];
        const hash = $e7b737bc38c0792a$var$getEventHash(event);
        if (hash !== event.id) {
            event[$e7b737bc38c0792a$var$verifiedSymbol] = false;
            return false;
        }
        try {
            const valid = (0, $lPiFO.schnorr).verify(event.sig, hash, event.pubkey);
            event[$e7b737bc38c0792a$var$verifiedSymbol] = valid;
            return valid;
        } catch (err) {
            event[$e7b737bc38c0792a$var$verifiedSymbol] = false;
            return false;
        }
    }
};
function $e7b737bc38c0792a$var$serializeEvent(evt) {
    if (!$e7b737bc38c0792a$var$validateEvent(evt)) throw new Error("can't serialize event with wrong or missing properties");
    return JSON.stringify([
        0,
        evt.pubkey,
        evt.created_at,
        evt.kind,
        evt.tags,
        evt.content
    ]);
}
function $e7b737bc38c0792a$var$getEventHash(event) {
    let eventHash = (0, $kHnZL.sha256)($e7b737bc38c0792a$var$utf8Encoder.encode($e7b737bc38c0792a$var$serializeEvent(event)));
    return (0, $9mdbq.bytesToHex)(eventHash);
}
var $e7b737bc38c0792a$var$i = new $e7b737bc38c0792a$var$JS();
var $e7b737bc38c0792a$var$generateSecretKey = $e7b737bc38c0792a$var$i.generateSecretKey;
var $e7b737bc38c0792a$var$getPublicKey = $e7b737bc38c0792a$var$i.getPublicKey;
var $e7b737bc38c0792a$var$finalizeEvent = $e7b737bc38c0792a$var$i.finalizeEvent;
var $e7b737bc38c0792a$var$verifyEvent = $e7b737bc38c0792a$var$i.verifyEvent;
// nip98.ts
var $e7b737bc38c0792a$var$_authorizationScheme = "Nostr ";
async function $e7b737bc38c0792a$export$257b2d10b709d8ef(loginUrl, httpMethod, sign, includeAuthorizationScheme = false, payload) {
    const event = {
        kind: $e7b737bc38c0792a$var$HTTPAuth,
        tags: [
            [
                "u",
                loginUrl
            ],
            [
                "method",
                httpMethod
            ]
        ],
        created_at: Math.round(new Date().getTime() / 1e3),
        content: ""
    };
    if (payload) event.tags.push([
        "payload",
        $e7b737bc38c0792a$export$826910beb1296573(payload)
    ]);
    const signedEvent = await sign(event);
    const authorizationScheme = includeAuthorizationScheme ? $e7b737bc38c0792a$var$_authorizationScheme : "";
    return authorizationScheme + (0, $7i98v.base64).encode($e7b737bc38c0792a$var$utf8Encoder.encode(JSON.stringify(signedEvent)));
}
async function $e7b737bc38c0792a$export$56cd50188d1996d0(token, url, method) {
    const event = await $e7b737bc38c0792a$export$edacef14511132fc(token).catch((error)=>{
        throw error;
    });
    const valid = await $e7b737bc38c0792a$export$d08d852dd562b1ce(event, url, method).catch((error)=>{
        throw error;
    });
    return valid;
}
async function $e7b737bc38c0792a$export$edacef14511132fc(token) {
    if (!token) throw new Error("Missing token");
    token = token.replace($e7b737bc38c0792a$var$_authorizationScheme, "");
    const eventB64 = $e7b737bc38c0792a$var$utf8Decoder.decode((0, $7i98v.base64).decode(token));
    if (!eventB64 || eventB64.length === 0 || !eventB64.startsWith("{")) throw new Error("Invalid token");
    const event = JSON.parse(eventB64);
    return event;
}
function $e7b737bc38c0792a$export$b06dba36543e1902(event) {
    if (!event.created_at) return false;
    return Math.round(new Date().getTime() / 1e3) - event.created_at < 60;
}
function $e7b737bc38c0792a$export$7b0d2e684a2299e2(event) {
    return event.kind === $e7b737bc38c0792a$var$HTTPAuth;
}
function $e7b737bc38c0792a$export$b7b21271725405ca(event, url) {
    const urlTag = event.tags.find((t)=>t[0] === "u");
    if (!urlTag) return false;
    return urlTag.length > 0 && urlTag[1] === url;
}
function $e7b737bc38c0792a$export$b432f3866c21c79(event, method) {
    const methodTag = event.tags.find((t)=>t[0] === "method");
    if (!methodTag) return false;
    return methodTag.length > 0 && methodTag[1].toLowerCase() === method.toLowerCase();
}
function $e7b737bc38c0792a$export$826910beb1296573(payload) {
    const hash = (0, $kHnZL.sha256)($e7b737bc38c0792a$var$utf8Encoder.encode(JSON.stringify(payload)));
    return (0, $9mdbq.bytesToHex)(hash);
}
function $e7b737bc38c0792a$export$d255a08d6537a75a(event, payload) {
    const payloadTag = event.tags.find((t)=>t[0] === "payload");
    if (!payloadTag) return false;
    const payloadHash = $e7b737bc38c0792a$export$826910beb1296573(payload);
    return payloadTag.length > 0 && payloadTag[1] === payloadHash;
}
async function $e7b737bc38c0792a$export$d08d852dd562b1ce(event, url, method, body) {
    if (!$e7b737bc38c0792a$var$verifyEvent(event)) throw new Error("Invalid nostr event, signature invalid");
    if (!$e7b737bc38c0792a$export$7b0d2e684a2299e2(event)) throw new Error("Invalid nostr event, kind invalid");
    if (!$e7b737bc38c0792a$export$b06dba36543e1902(event)) throw new Error("Invalid nostr event, created_at timestamp invalid");
    if (!$e7b737bc38c0792a$export$b7b21271725405ca(event, url)) throw new Error("Invalid nostr event, url tag invalid");
    if (!$e7b737bc38c0792a$export$b432f3866c21c79(event, method)) throw new Error("Invalid nostr event, method tag invalid");
    if (Boolean(body) && typeof body === "object" && Object.keys(body).length > 0) {
        if (!$e7b737bc38c0792a$export$d255a08d6537a75a(event, body)) throw new Error("Invalid nostr event, payload tag does not match request body hash");
    }
    return true;
}


// nip96.ts

var $kHnZL = parcelRequire("kHnZL");

var $9mdbq = parcelRequire("9mdbq");
// kinds.ts
var $d776eee2ec6a281b$var$FileServerPreference = 10096;
function $d776eee2ec6a281b$export$37deb8233a88024d(config) {
    if (Boolean(config.api_url) == false) return false;
    if (Boolean(config.delegated_to_url) && Boolean(config.api_url)) return false;
    return true;
}
async function $d776eee2ec6a281b$export$93c8a64627ff1aab(serverUrl) {
    const HTTPROUTE = "/.well-known/nostr/nip96.json";
    let fetchUrl = "";
    try {
        const { origin: origin } = new URL(serverUrl);
        fetchUrl = origin + HTTPROUTE;
    } catch (error) {
        throw new Error("Invalid URL");
    }
    try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(`Error fetching ${fetchUrl}: ${response.statusText}`);
        const data = await response.json();
        if (!data) throw new Error("No data");
        if (!$d776eee2ec6a281b$export$37deb8233a88024d(data)) throw new Error("Invalid configuration data");
        return data;
    } catch (_) {
        throw new Error(`Error fetching.`);
    }
}
function $d776eee2ec6a281b$export$415eea9f01779257(response) {
    if (typeof response !== "object" || response === null) return false;
    if (!response.status || !response.message) return false;
    if (response.status !== "success" && response.status !== "error" && response.status !== "processing") return false;
    if (typeof response.message !== "string") return false;
    if (response.status === "processing" && !response.processing_url) return false;
    if (response.processing_url) {
        if (typeof response.processing_url !== "string") return false;
    }
    if (response.status === "success" && !response.nip94_event) return false;
    if (response.nip94_event) {
        if (!response.nip94_event.tags || !Array.isArray(response.nip94_event.tags) || response.nip94_event.tags.length === 0) return false;
        for (const tag of response.nip94_event.tags){
            if (!Array.isArray(tag) || tag.length !== 2) return false;
            if (typeof tag[0] !== "string" || typeof tag[1] !== "string") return false;
        }
        if (!response.nip94_event.tags.find((t)=>t[0] === "url")) return false;
        if (!response.nip94_event.tags.find((t)=>t[0] === "ox")) return false;
    }
    return true;
}
async function $d776eee2ec6a281b$export$a5575dbeeffdad98(file, serverApiUrl, nip98AuthorizationHeader, optionalFormDataFields) {
    const formData = new FormData();
    optionalFormDataFields && Object.entries(optionalFormDataFields).forEach(([key, value])=>{
        if (value) formData.append(key, value);
    });
    formData.append("file", file);
    const response = await fetch(serverApiUrl, {
        method: "POST",
        headers: {
            Authorization: nip98AuthorizationHeader
        },
        body: formData
    });
    if (response.ok === false) {
        if (response.status === 413) throw new Error("File too large!");
        if (response.status === 400) throw new Error("Bad request! Some fields are missing or invalid!");
        if (response.status === 403) throw new Error("Forbidden! Payload tag does not match the requested file!");
        if (response.status === 402) throw new Error("Payment required!");
        throw new Error("Unknown error in uploading file!");
    }
    try {
        const parsedResponse = await response.json();
        if (!$d776eee2ec6a281b$export$415eea9f01779257(parsedResponse)) throw new Error("Invalid response from the server!");
        return parsedResponse;
    } catch (error) {
        throw new Error("Error parsing JSON response!");
    }
}
function $d776eee2ec6a281b$export$f7e922befc7d5683(fileHash, serverDownloadUrl, fileExtension) {
    let downloadUrl = `${serverDownloadUrl}/${fileHash}`;
    if (fileExtension) downloadUrl += fileExtension;
    return downloadUrl;
}
async function $d776eee2ec6a281b$export$dccb98b97a3cb8be(fileHash, serverApiUrl, nip98AuthorizationHeader) {
    if (!serverApiUrl.endsWith("/")) serverApiUrl += "/";
    const deleteUrl = `${serverApiUrl}${fileHash}`;
    const response = await fetch(deleteUrl, {
        method: "DELETE",
        headers: {
            Authorization: nip98AuthorizationHeader
        }
    });
    if (!response.ok) throw new Error("Error deleting file!");
    try {
        return await response.json();
    } catch (error) {
        throw new Error("Error parsing JSON response!");
    }
}
function $d776eee2ec6a281b$export$66c9f779a896bfd4(response) {
    if (typeof response !== "object" || response === null) return false;
    if (!response.status || !response.message || !response.percentage) return false;
    if (response.status !== "processing" && response.status !== "error") return false;
    if (typeof response.message !== "string") return false;
    if (typeof response.percentage !== "number") return false;
    if (Number(response.percentage) < 0 || Number(response.percentage) > 100) return false;
    return true;
}
async function $d776eee2ec6a281b$export$d4f4662b1a7981b1(processingUrl) {
    const response = await fetch(processingUrl);
    if (!response.ok) throw new Error(`Failed to retrieve processing status. Server responded with status: ${response.status}`);
    try {
        const parsedResponse = await response.json();
        if (response.status === 201) {
            if (!$d776eee2ec6a281b$export$415eea9f01779257(parsedResponse)) throw new Error("Invalid response from the server!");
            return parsedResponse;
        }
        if (response.status === 200) {
            if (!$d776eee2ec6a281b$export$66c9f779a896bfd4(parsedResponse)) throw new Error("Invalid response from the server!");
            return parsedResponse;
        }
        throw new Error("Invalid response from the server!");
    } catch (error) {
        throw new Error("Error parsing JSON response!");
    }
}
function $d776eee2ec6a281b$export$254e42fe37b2caff(serverUrls) {
    serverUrls = serverUrls.filter((serverUrl)=>{
        try {
            new URL(serverUrl);
            return true;
        } catch (error) {
            return false;
        }
    });
    return {
        kind: $d776eee2ec6a281b$var$FileServerPreference,
        content: "",
        tags: serverUrls.map((serverUrl)=>[
                "server",
                serverUrl
            ]),
        created_at: Math.floor(Date.now() / 1e3)
    };
}
async function $d776eee2ec6a281b$export$ade917624c25aeb4(file) {
    return (0, $9mdbq.bytesToHex)((0, $kHnZL.sha256)(new Uint8Array(await file.arrayBuffer())));
}


window.Alpine = (0, $dc6El.default);
/*
function getServerApiURL() {
  const hostname = window.location.hostname
  const protocol = window.location.protocol
  const path = '/api/v2/nip96/upload'
  return `${protocol}//${hostname}${path}`
}

async function deleteMedia(mediaUrl) {
  const serverApiUrl = getServerApiURL()
  const cleanFileHash = mediaUrl.split('/').pop()
  console.log('serverApiUrl', serverApiUrl)
  const urlToSign = `${serverApiUrl}/${cleanFileHash}`
  const token = await getToken(urlToSign, 'DELETE', async (e) => window.nostr.signEvent(e), true)
  console.log('token', token)
  console.log('cleanFileHash', cleanFileHash)
  const res = await deleteFile(cleanFileHash, serverApiUrl, token)
  console.log(res)
}
  */ document.addEventListener("alpine:init", ()=>{
    (0, $dc6El.default).data("deleteMediaComponent", ()=>({
            filename: "",
            isLoading: false,
            async deleteMedia (mediaUrl) {
                this.isLoading = true;
                try {
                    const serverApiUrl = this.getServerApiURL();
                    const cleanFileHash = mediaUrl.split("/").pop();
                    if (!cleanFileHash) throw new Error("Invalid media URL, hash or filename");
                    // Try getting user npub to see if extension is functional
                    const userNpub = await window.nostr.getPublicKey();
                    if (!userNpub) throw new Error("Nostr extension is not installed or not enabled");
                    console.log("serverApiUrl", serverApiUrl);
                    const urlToSign = `${serverApiUrl}/${cleanFileHash}`;
                    const token = await (0, $e7b737bc38c0792a$export$257b2d10b709d8ef)(urlToSign, "DELETE", async (e)=>window.nostr.signEvent(e), true);
                    console.log("token", token);
                    console.log("cleanFileHash", cleanFileHash);
                    const res = await (0, $d776eee2ec6a281b$export$dccb98b97a3cb8be)(cleanFileHash, serverApiUrl, token);
                    console.log(res);
                    if (res.status === "error") alert(`Delete failed: ${res.message}`);
                    else alert("File deleted successfully");
                } catch (error) {
                    alert(`An error occurred: ${error.message}`);
                } finally{
                    this.isLoading = false;
                }
            },
            getServerApiURL () {
                const hostname = window.location.hostname;
                const protocol = window.location.protocol;
                const path = "/api/v2/nip96/upload";
                return `${protocol}//${hostname}${path}`;
            }
        }));
});
(0, $dc6El.default).start();

})();
//# sourceMappingURL=delete.js.map
